<template>
  <div class="mailbox-wrapper" :class="{'blockPage': pageIsBlocked}">
    <div class="sidebar overflow-y-auto">
      <div class="heading-block">
        <button class="sidebar__button" :class="{'blockPage': pageIsBlocked}" @click="$refs.createAccountModal.showModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.1997 7.99688C21.1997 6.50571 19.9909 5.29688 18.4997 5.29688H6.07715C4.81935 5.29688 3.79971 6.31652 3.79971 7.57431C3.79971 8.39709 4.2435 9.1559 4.96061 9.55927L11.176 13.0554C11.9979 13.5178 13.0015 13.5178 13.8234 13.0554L19.7997 9.69377V15.9969C19.7997 16.7148 19.2177 17.2969 18.4997 17.2969H12.4997C12.1131 17.2969 11.7997 17.6103 11.7997 17.9969C11.7997 18.3835 12.1131 18.6969 12.4997 18.6969H18.4997C19.9909 18.6969 21.1997 17.488 21.1997 15.9969V7.99688ZM19.7997 8.08748L13.137 11.8352C12.7413 12.0578 12.2581 12.0578 11.8624 11.8352L5.64697 8.33907C5.37069 8.18366 5.19971 7.89131 5.19971 7.57431C5.19971 7.08972 5.59255 6.69687 6.07715 6.69687H18.4997C19.2177 6.69687 19.7997 7.2789 19.7997 7.99688V8.08748ZM5.49971 12.2969C5.11311 12.2969 4.79971 12.6103 4.79971 12.9969V15.7969H1.99971C1.61311 15.7969 1.29971 16.1103 1.29971 16.4969C1.29971 16.8835 1.61311 17.1969 1.99971 17.1969H4.79971V19.9969C4.79971 20.3835 5.11311 20.6969 5.49971 20.6969C5.88631 20.6969 6.19971 20.3835 6.19971 19.9969V17.1969H8.99971C9.38631 17.1969 9.69971 16.8835 9.69971 16.4969C9.69971 16.1103 9.38631 15.7969 8.99971 15.7969H6.19971V12.9969C6.19971 12.6103 5.88631 12.2969 5.49971 12.2969Z" fill="#094172"/>
          </svg>
          Add Account
          <CreateAccountModal @addAccount="createAccount($event)" ref="createAccountModal"></CreateAccountModal>
        </button>
        <button class="sidebar__button" v-on:click="openInNewWindow">
          Open in New Window
        </button>
      </div>
      <div class="all-lists-row h44 min-h-44px" @click="setActiveFolder()">
        <div class="left-col">
          <button class="all-lists-btn">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4759 1.64844H10.9932H8.27891H4.74203C3.69099 1.64844 2.73593 2.27123 2.29576 3.24363L0.0641968 8.17357C0.0219023 8.267 0 8.36867 0 8.47157V12.2526C0 13.7684 1.20609 14.9972 2.69388 14.9972H13.3061C14.7939 14.9972 16 13.7684 16 12.2526V8.47157C16 8.3778 15.9818 8.28495 15.9465 8.19836L13.9633 3.33926C13.5455 2.31552 12.5641 1.64844 11.4759 1.64844ZM3.56462 3.83837C3.77655 3.37018 4.2364 3.07031 4.74245 3.07031H8.27933H10.9936H11.4763C12.0003 3.07031 12.4728 3.3915 12.674 3.88441L14.2552 7.75874H11.4018C11.134 7.75874 10.8898 7.91472 10.7731 8.16027L10.4112 8.92211C10.1945 9.37815 9.74101 9.66782 9.24372 9.66782H6.79499C6.31566 9.66782 5.8754 9.39849 5.65012 8.96743L5.21553 8.13587C5.09422 7.90376 4.85716 7.75874 4.59906 7.75874H1.79004L3.56462 3.83837Z" fill="#9AA3B0"/>
            </svg>
            All Inboxes
          </button>
          <span class="num" v-if="allMailsCount.unread_mails_count != 0">{{allMailsCount.unread_mails_count}}</span>
        </div>
        <div class="right-col">
          <span class="num">{{allMailsCount.all_mails_count}}</span>
        </div>
      </div>
      <div class="content-block">
        <draggable v-model="account_list" handle=".drag-btn">
          <AccountItem
              :showFoldersIds="showFoldersIds"
              @showFolderEmit="showFolderEmit"
              :dragFolderItem="dragStart"
              @moveToFolderDrop="moveToFolderDrop"
              @dragStart="dragStartFolder"
              @dragEnd="dragEndFolder"
              :dragModeFolderActive="dragStart !== null"
              :dragModeActive="dragModeActive"
              :getIdDragAccount="getIdDragAccount"
            :class="{'active-account': activeAccount == account.id, 'all-cursor-default all-transition-none': dragModeActive}"
            @setActiveAccountInfo="setActiveAccountInfo"
            v-for="account in account_list" :key="account.id"
            :activeFolder="activeFolder"
              :dragItem="idItem"
              :mailsList="mailsList"
              :checkedEmails="checkedEmails"
            :accountInfo="account">
          </AccountItem>
        </draggable>
      </div>
      <transition name="slide-bottom">
        <NewMailToast @showNewMessage="getMailDetailInfo($event.mailId, $event.folderId)" ref="mailToast"></NewMailToast>
      </transition>
      <FolderSettings
        ref="folderSettingsMenu"
        :accountsInfo="account_list"
        @createFolder="createFolder($event)"
        @saveFolder="saveFolder($event)"
      ></FolderSettings>
      <UploadEml @fileLoaded="getAccounts" ref="uploadEmlComponent"></UploadEml>
    </div>
    <div class="content" v-if="!activeAccount">
      <div class="heading-block" :class="{disabled: isDisabledActivityButtons}">
        <button class="heading-block__button" @click="$refs.createEmailModal.showModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1474 12.1975C11.1979 12.129 11.2534 12.0645 11.3136 12.0044L17.2201 6.09781C17.6106 5.70728 18.2438 5.70728 18.6343 6.09781L18.8906 6.35407C19.2811 6.7446 19.2811 7.37776 18.8906 7.76829L12.984 13.6748C12.9239 13.735 12.8594 13.7905 12.7909 13.841L10.792 15.3151C10.0535 15.8597 9.12868 14.9349 9.6733 14.1964L11.1474 12.1975ZM19.2193 5.51288C18.8287 5.12236 18.8287 4.48919 19.2193 4.09867L19.7282 3.58977C20.1187 3.19924 20.7518 3.19924 21.1424 3.58977L21.3986 3.84603C21.7892 4.23656 21.7892 4.86972 21.3986 5.26025L20.8897 5.76915C20.4992 6.15967 19.866 6.15967 19.4755 5.76915L19.2193 5.51288Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.9998 5.59224C6.28183 5.59224 5.6998 6.17427 5.6998 6.89224V17.8922C5.6998 18.6102 6.28183 19.1922 6.9998 19.1922H16.9998C17.7178 19.1922 18.2998 18.6102 18.2998 17.8922V12.4977C18.2998 12.1111 18.6132 11.7977 18.9998 11.7977C19.3864 11.7977 19.6998 12.1111 19.6998 12.4977V17.8922C19.6998 19.3834 18.491 20.5922 16.9998 20.5922H6.9998C5.50864 20.5922 4.2998 19.3834 4.2998 17.8922V6.89224C4.2998 5.40107 5.50864 4.19224 6.9998 4.19224H12.9998C13.3864 4.19224 13.6998 4.50564 13.6998 4.89224C13.6998 5.27884 13.3864 5.59224 12.9998 5.59224H6.9998Z" fill="white"/>
          </svg>
          New message
        </button>

        <button
          class="heading-block__button_light"
          :class="{disabled: isFromDifferentAccounts.length > 1}"
          v-if="!['Draft'].includes(activeFolderName)"
          @click="showReplyForm">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.57209 11.1535C2.4748 11.2319 2.47238 11.3793 2.56705 11.4608L10.7906 18.5422C10.9202 18.6539 11.1211 18.5618 11.1211 18.3907V14.2028C11.1211 14.0923 11.2106 14.0028 11.3211 14.0028H11.6974C15.8484 14.0028 17.8808 15.0054 19.7893 17.8495C19.9017 18.017 20.1636 17.9382 20.1533 17.7367C19.8939 12.6727 16.8304 9.18184 11.6974 9.18184H11.3211C11.2106 9.18184 11.1211 9.09229 11.1211 8.98184V4.68475C11.1211 4.51674 10.9265 4.4236 10.7956 4.529L2.57209 11.1535Z" stroke="#094172" stroke-width="1.4"/>
          </svg>
          Reply
        </button>

        <button
          class="heading-block__button_light"
          :class="{disabled: isFromDifferentAccounts.length > 1}"
          @click="showForwardForm"
          v-if="!['Draft'].includes(activeFolderName)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.4282 11.1535C21.5255 11.2319 21.5279 11.3793 21.4332 11.4608L13.2097 18.5422C13.08 18.6539 12.8792 18.5618 12.8792 18.3907V14.2028C12.8792 14.0923 12.7896 14.0028 12.6792 14.0028H12.3029C8.15185 14.0028 6.11951 15.0054 4.21097 17.8495C4.09855 18.017 3.83665 17.9382 3.84698 17.7367C4.10644 12.6727 7.16991 9.18184 12.3029 9.18184H12.6792C12.7896 9.18184 12.8792 9.09229 12.8792 8.98184V4.68475C12.8792 4.51674 13.0738 4.4236 13.2047 4.529L21.4282 11.1535Z" stroke="#094172" stroke-width="1.4"/>
          </svg>
          Forward
        </button>

        <button class="heading-block__button_light" @click="showMoveToModal()" :class="{disabled: isFromDifferentAccounts.length > 1}">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.1998 5.4C6.48183 5.4 5.89981 5.98203 5.89981 6.7V7.7C5.89981 8.0866 5.5864 8.4 5.19981 8.4C4.81321 8.4 4.4998 8.0866 4.4998 7.7V6.7C4.4998 5.20883 5.70864 4 7.1998 4H10.5392C11.5081 4 12.4027 4.51917 12.8834 5.36042L13.7317 6.3831C13.9632 6.78814 14.3939 7.03812 14.8604 7.03812H19.1998C20.691 7.03812 21.8998 8.24695 21.8998 9.73811V16.7C21.8998 18.1912 20.691 19.4 19.1998 19.4H15.1998C14.8132 19.4 14.4998 19.0866 14.4998 18.7C14.4998 18.3134 14.8132 18 15.1998 18H19.1998C19.9178 18 20.4998 17.418 20.4998 16.7V9.73811C20.4998 9.02014 19.9178 8.43811 19.1998 8.43811H14.8604C13.8915 8.43811 12.9969 7.91894 12.5162 7.07769L11.6679 6.05502C11.4364 5.64997 11.0057 5.4 10.5392 5.4H7.1998Z" fill="#094172"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.2998 15C2.2998 14.6134 2.61321 14.3 2.9998 14.3H10.3141L7.51829 11.4941C7.24541 11.2202 7.24621 10.777 7.52007 10.5041C7.79392 10.2313 8.23714 10.2321 8.51002 10.5059L12.4957 14.5059C12.7678 14.7791 12.7678 15.2209 12.4957 15.4941L8.51002 19.4941C8.23714 19.7679 7.79392 19.7687 7.52007 19.4959C7.24621 19.223 7.24541 18.7798 7.51829 18.5059L10.3141 15.7H2.9998C2.61321 15.7 2.2998 15.3866 2.2998 15Z" fill="#094172"/>
          </svg>
          Move to
        </button>

        <button
          class="heading-block__button_light"
          @click="addToImportant()"
          v-if="!['Spam'].includes(activeFolderName)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.649 10.4526L12.0004 6.59285L10.3518 10.4526L6.17461 10.8317L9.33116 13.5996L8.40124 17.6953L12.0001 15.5434L15.5989 17.6957L14.6689 13.5996L17.8254 10.8317L13.649 10.4526ZM19.9582 10.1372C20.0635 10.4619 19.9661 10.8165 19.7101 11.0411L16.2187 14.1026L17.2482 18.6366C17.3235 18.97 17.1941 19.3147 16.9175 19.5147C16.6415 19.7146 16.2741 19.7306 15.982 19.556L12 17.1747L8.01729 19.556C7.88264 19.6366 7.73188 19.6766 7.58125 19.6766C7.40595 19.6766 7.23127 19.6227 7.08258 19.5147C6.80597 19.3147 6.67657 18.97 6.75189 18.6366L7.78132 14.1026L4.28993 11.0411C4.03382 10.8165 3.93653 10.4612 4.04188 10.1372C4.14784 9.81381 4.43459 9.58444 4.77322 9.55319L9.39268 9.13387L11.218 4.86036C11.3519 4.54639 11.6587 4.34375 12 4.34375C12.3413 4.34375 12.648 4.54639 12.7828 4.86036L14.6081 9.13387L19.2268 9.55319C19.5655 9.58383 19.8528 9.8132 19.9582 10.1372Z" fill="#094172"/>
          </svg>
          Important
        </button>

        <button class="heading-block__button_light tags-button" @click="showTagsModal" >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.538 11.3421L11.338 18.5421C11.3005 18.5796 11.2519 18.6 11.2 18.6C11.1444 18.6 11.0928 18.5769 11.0579 18.5421L5.46285 12.947C5.41892 12.9015 5.4 12.8496 5.4 12.8C5.4 12.7448 5.4199 12.696 5.46196 12.6539L12.6531 5.46283C12.6985 5.41893 12.7504 5.4 12.8 5.4H18.4C18.5108 5.4 18.6 5.48919 18.6 5.60001V11.2C18.6 11.2569 18.5792 11.3014 18.5449 11.3352L18.538 11.3421ZM11.668 4.468L4.47201 11.664C4.18 11.956 4 12.356 4 12.8C4 13.24 4.18 13.64 4.468 13.932L10.068 19.532C10.356 19.82 10.76 20 11.2 20C11.64 20 12.04 19.82 12.328 19.532L19.528 12.332C19.82 12.044 20 11.644 20 11.2V5.60001C20 4.71599 19.284 4 18.4 4H12.8C12.36 4 11.96 4.18 11.668 4.468Z" fill="#094172"/>
            <path d="M17 8.2C17 8.86401 16.464 9.4 15.8 9.4C15.136 9.4 14.6 8.86401 14.6 8.2C14.6 7.53599 15.136 7 15.8 7C16.464 7 17 7.53599 17 8.2Z" fill="#094172"/>
          </svg>
          Add tag
          <TagsModal @addTagsToMail="addTagsToMail($event)" ref="tagsModal"></TagsModal>
        </button>

        <button
          class="heading-block__button_light"
          @click="moveToSpam()"
          v-if="!['Draft', 'Spam', 'Sent'].includes(activeFolderName) || !activeFolderName">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1534 17.5916L18.9213 12.7974C19.2071 12.3023 19.2071 11.6924 18.9213 11.1974L16.1534 6.40313C15.8675 5.90808 15.3393 5.60313 14.7677 5.60313L9.23182 5.60313C8.66019 5.60313 8.13199 5.90808 7.84618 6.40313L5.07823 11.1974C4.79241 11.6924 4.79241 12.3023 5.07823 12.7974L7.84617 17.5916C8.13199 18.0866 8.66019 18.3916 9.23182 18.3916H14.7677C15.3393 18.3916 15.8675 18.0866 16.1534 17.5916ZM20.1337 13.4974C20.6696 12.5691 20.6696 11.4256 20.1337 10.4974L17.3658 5.70313C16.8299 4.77492 15.8395 4.20313 14.7677 4.20313L9.23182 4.20312C8.16002 4.20312 7.16964 4.77492 6.63374 5.70313L3.86579 10.4974C3.32989 11.4256 3.32989 12.5691 3.86579 13.4974L6.63374 18.2916C7.16964 19.2198 8.16002 19.7916 9.23182 19.7916H14.7677C15.8395 19.7916 16.8299 19.2198 17.3658 18.2916L20.1337 13.4974Z" fill="#094172"/>
            <path d="M15.0776 14.0461L13.1045 12.073L15.0777 10.0998C15.3604 9.81705 15.3604 9.35798 15.0776 9.07516C14.7948 8.79243 14.3358 8.79243 14.053 9.07516L12.0798 11.0484L10.1066 9.07516C9.82392 8.79243 9.36484 8.79243 9.08212 9.07516C8.7993 9.35798 8.7993 9.81705 9.08202 10.0998L11.0552 12.073L9.08212 14.0461C8.7993 14.3289 8.7993 14.788 9.08202 15.0707C9.36484 15.3535 9.82392 15.3535 10.1067 15.0707L12.0798 13.0976L14.0529 15.0707C14.3358 15.3535 14.7948 15.3535 15.0777 15.0707C15.3604 14.788 15.3604 14.3289 15.0776 14.0461Z" fill="#094172"/>
          </svg>
          To spam
        </button>
        <button
          class="heading-block__button_light"
          @click="moveToSpam(null, false)"
          v-if="['Spam'].includes(activeFolderName)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.01736 9.78525L6.71267 7.00237L9.01736 4.21949C9.28441 3.91345 9.25326 3.44872 8.94722 3.18143C8.64119 2.91438 8.1767 2.94578 7.90916 3.25157L5.18172 6.51852C4.93943 6.79562 4.93943 7.20934 5.18172 7.48644L7.9092 10.7534C8.05485 10.9197 8.25865 11.005 8.46365 11.005C8.63532 11.005 8.80769 10.9452 8.94722 10.8233C9.25329 10.556 9.28465 10.0913 9.01736 9.78525Z" fill="#094172"/>
            <path d="M13.6538 6.26562H5.73568C5.32934 6.26562 5 6.59493 5 7.0013C5 7.40764 5.32934 7.73698 5.73568 7.73698H13.6538C15.7904 7.73698 17.5286 9.60036 17.5286 11.9785C17.5286 14.3567 15.7904 16.4862 13.6538 16.4862H6.71661C6.31027 16.4862 5.98093 16.8155 5.98093 17.2219C5.98093 17.6282 6.31027 17.9576 6.71661 17.9576H13.6538C16.6014 17.9576 19 15.212 19 11.9785C19 8.74505 16.6017 6.26562 13.6538 6.26562Z" fill="#094172"/>
          </svg>

          Not spam
        </button>
        <button
          class="heading-block__button_light"
          @click="moveToArchive()"
          v-if="['Incoming', 'Sent', 'Draft', 'Spam'].includes(activeFolderName) || !activeFolderName">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.12 9.96H19.72L18.76 19.24H5.96L5 9.96H6.76M18.12 9.96L18.6 7.4H16.52M18.12 9.96H6.76M6.76 9.96L6.12 7.4H8.2M8.2 7.4L7.72 5H17L16.52 7.4M8.2 7.4H16.52M9.96 13.32H14.76" stroke="#094172" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          To archive
        </button>
        <button
          class="heading-block__button_light"
          @click="deleteForever()"
          v-if="['Draft', 'Archive'].includes(activeFolderName)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z" fill="#094172"/>
          </svg>
          Delete forever
        </button>

        <button class="heading-action-menu" v-click-outside="hideActionButtonsMenu" @click="actionButtonMenuIsVisible = true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.44 10.5576C7.23529 10.5576 7.88 11.2023 7.88 11.9976C7.88 12.7928 7.23529 13.4376 6.44 13.4376C5.64471 13.4376 5 12.7928 5 11.9976C5 11.2023 5.64471 10.5576 6.44 10.5576Z" fill="#094172"/>
            <circle cx="12.0005" cy="11.9975" r="1.44" transform="rotate(-90 12.0005 11.9975)" fill="#094172"/>
            <path d="M17.5591 10.5575C18.3544 10.5575 18.9991 11.2022 18.9991 11.9975C18.9991 12.7928 18.3544 13.4375 17.5591 13.4375C16.7639 13.4375 16.1191 12.7928 16.1191 11.9975C16.1191 11.2022 16.7639 10.5575 17.5591 10.5575Z" fill="#094172"/>
          </svg>

          <div class="heading-action-sub-menu" :class="{show: actionButtonMenuIsVisible}">
            <button
              class="heading-block__button_light"
              @click="moveToArchive()"
              v-if="!['Archive', 'Incoming', 'Sent', 'Draft', 'Spam'].includes(activeFolderName) && activeFolderName">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.12 9.96H19.72L18.76 19.24H5.96L5 9.96H6.76M18.12 9.96L18.6 7.4H16.52M18.12 9.96H6.76M6.76 9.96L6.12 7.4H8.2M8.2 7.4L7.72 5H17L16.52 7.4M8.2 7.4H16.52M9.96 13.32H14.76" stroke="#094172" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              To archive
            </button>
            <button
              class="heading-block__button_light"
              @click="moveToArchive(null, false)"
              v-if="['Archive'].includes(activeFolderName)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.01736 9.78525L6.71267 7.00237L9.01736 4.21949C9.28441 3.91345 9.25326 3.44872 8.94722 3.18143C8.64119 2.91438 8.1767 2.94578 7.90916 3.25157L5.18172 6.51852C4.93943 6.79562 4.93943 7.20934 5.18172 7.48644L7.9092 10.7534C8.05485 10.9197 8.25865 11.005 8.46365 11.005C8.63532 11.005 8.80769 10.9452 8.94722 10.8233C9.25329 10.556 9.28465 10.0913 9.01736 9.78525Z" fill="#2C2C2C"/>
                <path d="M13.6538 6.26562H5.73568C5.32934 6.26562 5 6.59493 5 7.0013C5 7.40764 5.32934 7.73698 5.73568 7.73698H13.6538C15.7904 7.73698 17.5286 9.60036 17.5286 11.9785C17.5286 14.3567 15.7904 16.4862 13.6538 16.4862H6.71661C6.31027 16.4862 5.98093 16.8155 5.98093 17.2219C5.98093 17.6282 6.31027 17.9576 6.71661 17.9576H13.6538C16.6014 17.9576 19 15.212 19 11.9785C19 8.74505 16.6017 6.26562 13.6538 6.26562Z" fill="#2C2C2C"/>
              </svg>

              Unarchive
            </button>
            <button
              class="heading-block__button_light"
              @click="deleteForever()"
              v-if="['Spam'].includes(activeFolderName)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z" fill="#094172"/>
              </svg>
              Delete forever
            </button>
            <button class="heading-block__button_light" @click="downloadEmails()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.3333 5V14M12.3333 14L16.3333 10.0143M12.3333 14L8.33332 10.0143M19 16V17C19 18.1046 18.1046 19 17 19H7.33333C6.22876 19 5.33333 18.1046 5.33333 17V16" stroke="#094172" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Download
            </button>
            <button class="heading-block__button_light" @click="addToUnread()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 8.5V16C4 17.1046 4.89543 18 6 18H18C19.1046 18 20 17.1046 20 16V8.5M4 8.5V8C4 6.89543 4.89543 6 6 6H18C19.1046 6 20 6.89543 20 8V8.5M4 8.5L11.0195 12.4485C11.6283 12.7909 12.3717 12.7909 12.9805 12.4485L20 8.5" stroke="#094172" stroke-width="1.4"/>
              </svg>
              <span v-if="!mailIsRead">Mark as unread</span>
              <span v-else>Mark as read</span>
            </button>
            <button
              class="heading-block__button_light"
              @click="addToImportant()"
              v-if="['Spam'].includes(activeFolderName)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.649 10.4526L12.0004 6.59285L10.3518 10.4526L6.17461 10.8317L9.33116 13.5996L8.40124 17.6953L12.0001 15.5434L15.5989 17.6957L14.6689 13.5996L17.8254 10.8317L13.649 10.4526ZM19.9582 10.1372C20.0635 10.4619 19.9661 10.8165 19.7101 11.0411L16.2187 14.1026L17.2482 18.6366C17.3235 18.97 17.1941 19.3147 16.9175 19.5147C16.6415 19.7146 16.2741 19.7306 15.982 19.556L12 17.1747L8.01729 19.556C7.88264 19.6366 7.73188 19.6766 7.58125 19.6766C7.40595 19.6766 7.23127 19.6227 7.08258 19.5147C6.80597 19.3147 6.67657 18.97 6.75189 18.6366L7.78132 14.1026L4.28993 11.0411C4.03382 10.8165 3.93653 10.4612 4.04188 10.1372C4.14784 9.81381 4.43459 9.58444 4.77322 9.55319L9.39268 9.13387L11.218 4.86036C11.3519 4.54639 11.6587 4.34375 12 4.34375C12.3413 4.34375 12.648 4.54639 12.7828 4.86036L14.6081 9.13387L19.2268 9.55319C19.5655 9.58383 19.8528 9.8132 19.9582 10.1372Z" fill="#094172"/>
              </svg>
              Important
            </button>
            <button
              class="heading-block__button_light"
              @click="multipleMailAttach = true"
              v-if="!['Spam'].includes(activeFolderName)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6329 16.1955L8.74753 18.0808C7.9659 18.8624 6.70011 18.8624 5.91914 18.081C5.13801 17.2998 5.13801 16.0339 5.91898 15.253L9.69035 11.4816C10.4713 10.7006 11.7372 10.7006 12.5182 11.4816C12.7786 11.7419 13.2007 11.7419 13.461 11.4816C13.7214 11.2212 13.7214 10.7991 13.461 10.5388C12.1593 9.23708 10.0492 9.23708 8.74753 10.5388L4.97619 14.3101C3.6745 15.6118 3.6745 17.7219 4.97619 19.0236C6.27773 20.326 8.388 20.326 9.69038 19.0236L11.5757 17.1382C11.8361 16.8779 11.8361 16.4558 11.5757 16.1954C11.3154 15.9351 10.8932 15.9351 10.6329 16.1955Z" fill="#094172"/>
                <path d="M19.0229 4.97627C17.7212 3.67458 15.6104 3.67458 14.3087 4.97627L12.0467 7.23828C11.7863 7.49863 11.7863 7.92076 12.0467 8.1811C12.307 8.44145 12.7292 8.44145 12.9895 8.1811L15.2515 5.91909C16.0325 5.13808 17.2991 5.13808 18.0801 5.91909C18.861 6.70006 18.861 7.96598 18.0801 8.74695L13.932 12.895C13.151 13.676 11.8852 13.676 11.1042 12.895C10.8438 12.6347 10.4217 12.6347 10.1614 12.895C9.90102 13.1553 9.90102 13.5775 10.1614 13.8378C11.4631 15.1395 13.5732 15.1395 14.8749 13.8378L19.0229 9.6898C20.3246 8.3881 20.3246 6.27797 19.0229 4.97627Z" fill="#094172"/>
              </svg>
              Attach to...
            </button>
          </div>
        </button>
        <Pagination
          :class="{loading: mailListLoader}"
          :pagination="pagination"
          @goPrevPage="goPrevPage"
          @goNextPage="goNextPage"
        ></Pagination>
      </div>
      <div class="nav-block">
        <button class="nav-button" :class="{'active': mailsListType == ''}" @click="changeListType('')">All</button>
        <button class="nav-button" :class="{'active': mailsListType == 'is_read'}" @click="changeListType('is_read')">Unread</button>
        <button class="nav-button" :class="{'active': mailsListType == 'read'}" @click="changeListType('read')">Read</button>

        <button class="nav-button" :class="{'active': mailsListType == 'is_important'}" @click="changeListType('is_important')">Important</button>
        <button class="nav-button" :class="{'active': mailsListType == 'has_attachment'}" @click="changeListType('has_attachment')">Attached to</button>
        <button class="nav-button" :class="{'active': mailsListType == 'has_tag'}" @click="changeListType('has_tag')">Tagged</button>
        <mailFilter
          ref="mailFilter"
          :filters="filters"
          :accounts="accontsForDropdown"
          :hasActiveFilters="filters.hasActiveFilters"
          :mailsListType="mailsListType"
          :templates="filterTemplates"
          :activeFolder="activeFolder"
          @filterIsVisible="filterIsVisible($event)"
          @updateEmailFrom="filters.email_from = $event"
          @updateEmailTo="filters.email_to = $event"
          @subjectContains="filters.subject.contains = $event"
          @updSubject="filters.subject.subject_contains = $event,
                       filters.subject.subject_not_contains = $event"
          @textContains="filters.text.contains = $event"
          @updText="filters.text.text_contains = $event,
                    filters.text.text_not_contains = $event"
          @updDate="filters.date = $event"
          @updAccount="filters.account = $event"
          @applyFilters="setFilters"
          @clearFilters="clearFilters"
          @createFilterTemplate="createFilterTemplate"
          @changeTemplateName="changeFilterTemplateName($event)"
          @delTemplate="deleteFilterTemplate($event)"
          @applyTemplate="applyTemplate($event)"
          @editTemplate="editTemplate($event)"
          @saveFilterTemplate="saveFilterTemplate"
        ></mailFilter>
        <div class="search-block">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.8045 18.862L15.2545 14.312C16.1359 13.2233 16.6665 11.84 16.6665 10.3333C16.6665 6.84134 13.8252 4 10.3332 4C6.84128 4 4 6.84131 4 10.3333C4 13.8253 6.84131 16.6667 10.3333 16.6667C11.8399 16.6667 13.2232 16.136 14.3119 15.2547L18.8618 19.8047C18.9918 19.9347 19.1625 20 19.3332 20C19.5039 20 19.6745 19.9347 19.8045 19.8047C20.0652 19.544 20.0652 19.1227 19.8045 18.862ZM10.3333 15.3333C7.57596 15.3333 5.33333 13.0907 5.33333 10.3333C5.33333 7.57597 7.57596 5.33331 10.3333 5.33331C13.0906 5.33331 15.3332 7.57597 15.3332 10.3333C15.3332 13.0907 13.0906 15.3333 10.3333 15.3333Z" fill="#2C2C2C"/>
          </svg>
          <input type="text" class="search-input" placeholder="Search" v-model="search">

        </div>
      </div>
      <split-pane split="horizontal" :min-percent="20">
        <!-- Mail list -->
        <template slot="paneL">
          <div class="mail-loader" v-if="mailListLoader">
            <div class="sk-fading-circle">
              <div class="sk-circle sk-circle-1"></div>
              <div class="sk-circle sk-circle-2"></div>
              <div class="sk-circle sk-circle-3"></div>
              <div class="sk-circle sk-circle-4"></div>
              <div class="sk-circle sk-circle-5"></div>
              <div class="sk-circle sk-circle-6"></div>
              <div class="sk-circle sk-circle-7"></div>
              <div class="sk-circle sk-circle-8"></div>
              <div class="sk-circle sk-circle-9"></div>
              <div class="sk-circle sk-circle-10"></div>
              <div class="sk-circle sk-circle-11"></div>
              <div class="sk-circle sk-circle-12"></div>
            </div>
          </div>
          <div class="no-result-block" v-if="mailsList.length == 0">
            <div class="list-empty" v-if="search != ''">
              <svg width="81" height="80">
                <use xlink:href="#no_search_result_icn"></use>
              </svg>
              <span class="text">No results were found for your request</span>
            </div>
            <div class="list-empty" v-else>
              <svg width="81" height="80">
                <use xlink:href="#mail_placeholder_icn"></use>
              </svg>
              <span class="text">Email list is empty</span>
            </div>
          </div>
          <div class="mail-block-wrapper" ref="mailBlockWrapper" v-else>
            <div class="mails-block">
              <MailList
                  @changeOrdering="orderinCreatedAt = !orderinCreatedAt"
                  :orderinCreatedAt="orderinCreatedAt"
                  :activeMail="mailDetailInfo ? mailDetailInfo.id : -1"
                :ref="'mailsTable'"
                :emailsList="mailsList"
                :checkedEmails="checkedEmails"
                :activeFolderName="activeFolderName"
                @checkEmailItem="checkMailItem($event)"
                @checkAllEmails="checkAllEmails"
                @updateMailItem="updateMailItem($event)"
                @menuAction="mailMenuAction($event)"
              ></MailList>
            </div>
          </div>
        </template>
        <!-- Detail mail -->
        <template slot="paneR">
          <div class="mail-loader" v-if="mailDetailLoader">
            <div class="sk-fading-circle">
              <div class="sk-circle sk-circle-1"></div>
              <div class="sk-circle sk-circle-2"></div>
              <div class="sk-circle sk-circle-3"></div>
              <div class="sk-circle sk-circle-4"></div>
              <div class="sk-circle sk-circle-5"></div>
              <div class="sk-circle sk-circle-6"></div>
              <div class="sk-circle sk-circle-7"></div>
              <div class="sk-circle sk-circle-8"></div>
              <div class="sk-circle sk-circle-9"></div>
              <div class="sk-circle sk-circle-10"></div>
              <div class="sk-circle sk-circle-11"></div>
              <div class="sk-circle sk-circle-12"></div>
            </div>
          </div>
          <div class="w100Proc border-bottom border-color-gray p8-16 box-border d-flex pb2" v-if="mailDetailInfo && (mailDetailInfo.contracts.concat(mailDetailInfo.ports)).length != 0">
            <p class="fz16 fw500 text-dark mr4 mb6">Attached to:</p>
            <div class="wrap-attach">
              <div class="d-flex flex-wrap wrap-items-attach" :class="{'hideAttach': !showAllAttach}">
                <p v-if="(mailDetailInfo.contracts.concat(mailDetailInfo.ports)).length == 0" class="fz14 text-dark mt2">List is empty</p>

                <p class="p2-6 pr22 ml4 position-relative mb6 fz12 text-dark border-radius-100 bgc-light-blue d-flex align-items-center position-relative" v-for="(item, i) in (mailDetailInfo.contracts.concat(mailDetailInfo.ports))" :key="i">
                  {{item.name}} {{item.cp_date | formatDateFromCpDateWithotTimeZome}}
                  <svg v-on:click="unPinAttach(item)" class="position-absolute r6 cursor-pointer" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.53549 9.09341L6.94283 6.50076L9.53558 3.90801C9.79573 3.64785 9.79573 3.22542 9.53549 2.96518C9.27533 2.70502 8.8529 2.70502 8.59274 2.96518L6 5.55792L3.40726 2.96518C3.1471 2.70502 2.72467 2.70502 2.46451 2.96518C2.20427 3.22542 2.20427 3.64785 2.46442 3.90801L5.05717 6.50076L2.46451 9.09341C2.20427 9.35366 2.20427 9.77609 2.46442 10.0362C2.72467 10.2965 3.1471 10.2965 3.40734 10.0362L6 7.44359L8.59266 10.0362C8.8529 10.2965 9.27533 10.2965 9.53558 10.0362C9.79573 9.77609 9.79573 9.35366 9.53549 9.09341Z" fill="#2C2C2C"/>
                  </svg>

                </p>
              </div>
              <button class="blue-button-text fz14 fw500 ml4 mt2" v-on:click="showAllAttach = !showAllAttach" v-if="bollShowAll">
                {{!showAllAttach ? 'Show all' : 'Hide'}}
                <svg :class="{'rotateX180': showAllAttach}" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.27557 4.5C9.54284 4.5 9.67669 4.82314 9.4877 5.01213L6.21196 8.28787C6.0948 8.40502 5.90485 8.40502 5.7877 8.28787L2.51197 5.01213C2.32298 4.82314 2.45683 4.5 2.7241 4.5L9.27557 4.5Z" fill="#094172"/>
                </svg>
              </button>
            </div>

          </div>

          <div class="mail-detail-wrapper">
            <div class="mail-detail" v-if="mailDetailInfo && activeFolderName !== 'Draft'">
              <div class="name-row">
                <span class="name-text">{{mailDetailInfo.subject || '-'}}</span>
                <span class="tag" v-for="tag in mailDetailInfo.tags" :key="tag.id">
                  {{tag.title}}
                  <svg @click="deleteTag(tag.id, mailDetailInfo.id)" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.53549 9.09341L6.94283 6.50076L9.53558 3.90801C9.79573 3.64785 9.79573 3.22542 9.53549 2.96518C9.27533 2.70502 8.8529 2.70502 8.59274 2.96518L6 5.55792L3.40726 2.96518C3.1471 2.70502 2.72467 2.70502 2.46451 2.96518C2.20427 3.22542 2.20427 3.64785 2.46442 3.90801L5.05717 6.50076L2.46451 9.09341C2.20427 9.35366 2.20427 9.77609 2.46442 10.0362C2.72467 10.2965 3.1471 10.2965 3.40734 10.0362L6 7.44359L8.59266 10.0362C8.8529 10.2965 9.27533 10.2965 9.53558 10.0362C9.79573 9.77609 9.79573 9.35366 9.53549 9.09341Z" fill="#2C2C2C"/>
                  </svg>
                </span>
              </div>
              <div class="mail-info-block">
                <div class="mail-info-block__row">
                  <span class="name">From:</span>
                  <span class="text">{{mailDetailInfo.email_from || '-'}}</span>
                </div>
                <div class="mail-info-block__row">
                  <span class="name">To:</span>
                  <div class="text-block text-block_accordeon">
                    <span class="text-block__item crop">{{mailDetailInfo.email_to.join(', ')}}</span>
                  </div>
                </div>
                <div class="mail-info-block__row" v-if="Array.isArray(mailDetailInfo.email_to_cc) == true &&  mailDetailInfo.email_to_cc.filter(a=> a !== '').length">
                  <span class="name">CC:</span>
                  <div class="text-block text-block_accordeon">
                    <span class="text-block__item crop">{{mailDetailInfo.email_to_cc.filter(a=> a !== '').join(', ')}}</span>
                    <button 
                      class="accordeon-button" 
                      @click="toggleHiddenText($event)">
                      <span class="showAll">Show all</span>
                      <span class="hideAll">Hide all</span>
                    </button>
                  </div>
                </div>
                <div class="mail-info-block__row" v-if="Array.isArray(mailDetailInfo.email_to_bcc) == true && mailDetailInfo.email_to_bcc.filter(a=> a !== '').length">
                  <span class="name">BCC:</span>
                  <div class="text-block text-block_accordeon">
                    <span class="text-block__item crop">{{mailDetailInfo.email_to_bcc.filter(a=> a !== '').join(', ')}}</span>
                    <button 
                      class="accordeon-button" 
                      @click="toggleHiddenText($event)">
                      <span class="showAll">Show all</span>
                      <span class="hideAll">Hide all</span>
                    </button>
                  </div>
                </div>
                <div class="mail-info-block__row">
                  <span class="name">Sent:</span>
                  <span class="text">{{mailDetailInfo.created_at | formatDateAndTimeSpace2}}</span>
                </div>
                <div class="files-block">
                  <!-- <a download href="/" class="file" v-for="file in 5" :key="file">
                    <div class="file-img"></div>
                    <span class="file-name">file-name.pdf</span>
                    <span class="file-size">17 KB</span>
                  </a> -->
                  <div  class="file" v-for="(file, index) in mailDetailInfo.files" :key="index">
                    <div class="click-zone" v-on:click="openFile(file, index)">

                    </div>
                    <svg class="download-file" v-on:click="downloadFile(file)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.332 5V14M12.332 14L16.332 10.0143M12.332 14L8.33201 10.0143M18.9987 16V17C18.9987 18.1046 18.1033 19 16.9987 19H7.33202C6.22745 19 5.33202 18.1046 5.33202 17V16" stroke="#2C2C2C" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <div class="file-img"></div>
                    <span class="file-name">{{file.name || '-'}}</span>
                    <span class="file-size">{{file.size || 0}}</span>
                  </div>
                </div>
              </div>
              <div class="mail-text-block mb40">
                <p class="text saved-draft-text" v-if="getDraftTextToDetailMail" v-html="getDraftTextToDetailMail"></p>
                <p class="text" v-html="mailDetailInfo.text"></p>
                <MessageHistory
                    :hideParsedDate="true"
                  class="mails-history"
                  v-if="mailDetailInfo.reply_history.length != 0"
                  :messages="mailDetailInfo.reply_history"
                  :accordeonName="'historyMessage'"
                  @deleteHistoryItem="deleteHistoryItem($event)"
                ></MessageHistory>
              </div>
            </div>
            <DraftDetail 
              v-else-if="mailDetailInfo"
              :info="mailDetailInfo"
              :accounts="account_list"
              @updateDraftMails="updateDraftMails"
              @reSaveDraft="reSaveDraft($event)"
            ></DraftDetail>
            <!-- Empty block -->
            <div class="mail-placeholder" v-else>
              <svg width="81" height="80">
                <use xlink:href="#mail_placeholder_icn"></use>
              </svg>
              <span class="text">Select an email to see its content here</span>
            </div>
          </div>
        </template>
      </split-pane>
    </div>
    <div class="content" v-else>
      <div class="heading-block">
        <button class="create-folder-button" @click="showFolderSettings(getAccountInfo)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2236 13.2218H7.77926V9.77734C7.77926 9.3481 7.43077 8.99961 7.00139 8.99961C6.57215 8.99961 6.22367 9.3481 6.22367 9.77734V13.2218H2.77919C2.34995 13.2218 2.00146 13.5703 2.00146 13.9995C2.00146 14.4289 2.34995 14.7774 2.77919 14.7774H6.22367V18.2217C6.22367 18.6511 6.57215 18.9996 7.00139 18.9996C7.43077 18.9996 7.77926 18.6511 7.77926 18.2217V14.7774H11.2236C11.653 14.7774 12.0015 14.4289 12.0015 13.9995C12.0015 13.5703 11.653 13.2218 11.2236 13.2218Z" fill="#094172"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.19989 4.4C5.48192 4.4 4.8999 4.98203 4.8999 5.7V6.7C4.8999 7.0866 4.58649 7.4 4.1999 7.4C3.8133 7.4 3.4999 7.0866 3.4999 6.7V5.7C3.4999 4.20883 4.70873 3 6.19989 3H9.53925C10.5082 3 11.4028 3.51917 11.8835 4.36042L12.7318 5.3831C12.9633 5.78814 13.394 6.03812 13.8605 6.03812H18.1999C19.6911 6.03812 20.8999 7.24695 20.8999 8.73811V15.7C20.8999 17.1912 19.6911 18.4 18.1999 18.4H14.1999C13.8133 18.4 13.4999 18.0866 13.4999 17.7C13.4999 17.3134 13.8133 17 14.1999 17H18.1999C18.9179 17 19.4999 16.418 19.4999 15.7V8.73811C19.4999 8.02014 18.9179 7.43811 18.1999 7.43811H13.8605C12.8916 7.43811 11.997 6.91894 11.5163 6.07769L10.668 5.05502C10.4365 4.64997 10.0058 4.4 9.53925 4.4H6.19989Z" fill="#094172"/>
          </svg>
          Create Folder
        </button>
      </div>
      <div class="user-info-block">
        <span class="user-info-block__title">Account Details</span>
        <div class="user-block-row first signature-row">
          <div class="col">
            <span class="col__text">Signature</span>
          </div>
          <Signature 
            :accountInfo="getAccountInfo"
            @updateSignature="updateSignature($event)"
          ></Signature>
        </div>
        <div class="user-block-row">
          <div class="col">
            <span class="col__title">Account name</span>
            <span class="col__text">{{getAccountInfo.name}}</span>
          </div>
          <button class="col__button" @click="$refs.editNameAccountModal.showModal(getAccountInfo)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.9815 6.02666C17.3235 5.36566 16.4509 5 15.5175 5C14.5889 5 13.7116 5.36566 13.0536 6.02666L5.84634 13.276C5.74367 13.3791 5.68301 13.5104 5.65967 13.651L5.00635 18.2499C4.97835 18.4515 5.04368 18.6578 5.18835 18.8031C5.30968 18.9297 5.48234 19 5.65501 19C5.68301 19 5.70634 19 5.73434 18.9953L10.387 18.414C10.5316 18.3953 10.667 18.3296 10.7696 18.2265L17.9815 10.9725C19.3395 9.60357 19.3395 7.39086 17.9815 6.02666ZM10.0043 17.1342L6.42033 17.5795L6.92433 14.0495L12.8016 8.13624L15.8769 11.2256L10.0043 17.1342ZM17.0622 10.0489L16.8055 10.3068L13.7302 7.2174L13.9869 6.95957C14.3929 6.53765 14.9389 6.31263 15.5222 6.31263C16.1009 6.31263 16.6515 6.53765 17.0622 6.95488C17.4728 7.37211 17.7015 7.91591 17.7015 8.5019C17.7015 9.08321 17.4775 9.63639 17.0622 10.0489Z" fill="#094172"/>
            </svg>

            Edit name
          </button>
        </div>
        <div class="user-block-row">
          <div class="col">
            <span class="col__title">Email address</span>
            <span class="col__text">{{getAccountInfo.email}}</span>
          </div>
          <button class="col__button" @click="$refs.logoutModal.showModal(activeAccount)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6998 18.8354C12.6998 18.4488 12.3864 18.1354 11.9998 18.1354H6.9998C6.28183 18.1354 5.6998 17.5534 5.6998 16.8354L5.6998 7.16875C5.6998 6.45078 6.28184 5.86875 6.99981 5.86875L11.9998 5.86875C12.3864 5.86875 12.6998 5.55535 12.6998 5.16875C12.6998 4.78215 12.3864 4.46875 11.9998 4.46875L6.99981 4.46875C5.50864 4.46875 4.29981 5.67758 4.29981 7.16875L4.2998 16.8354C4.2998 18.3266 5.50863 19.5354 6.9998 19.5354H11.9998C12.3864 19.5354 12.6998 19.222 12.6998 18.8354Z" fill="#094172"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2998 11.9995C10.2998 11.6129 10.6132 11.2995 10.9998 11.2995H18.3141L15.5183 8.49356C15.2454 8.21971 15.2462 7.77649 15.5201 7.50362C15.7939 7.23074 16.2371 7.23154 16.51 7.5054L20.4957 11.5054C20.7678 11.7786 20.7678 12.2204 20.4957 12.4936L16.51 16.4936C16.2371 16.7674 15.7939 16.7682 15.5201 16.4953C15.2462 16.2225 15.2454 15.7793 15.5183 15.5054L18.3141 12.6995H10.9998C10.6132 12.6995 10.2998 12.3861 10.2998 11.9995Z" fill="#094172"/>
            </svg>
            Log out
          </button>
        </div>
      </div>
    </div>
    <SvgSprite></SvgSprite>
    <MoveToModal
      ref="moveToModal"
      :accounts="account_list"
      :messages="mailsList"
      @moveEmail="moveToFolder($event)"
    ></MoveToModal>
    <TextModal
      ref="logoutModal"
      :title="'Log out'"
      :applyBtnText="'Log out'"
      :cancelBtnText="'Cancel'"
      :text="`Are you sure you want to log out from ${getAccountInfo.name}?`"
      @apply="deleteAccount($event)"
    ></TextModal>
    <EditNameAccountModal
        @apply="updateName($event)" ref="editNameAccountModal">
    </EditNameAccountModal>
    <CreateEmailModal
      :accounts="account_list"
      @updateMails="updateFolders"
      ref="createEmailModal"
    ></CreateEmailModal>
    <ReplyEmailModal
      @updateMails="updateFolders"
      :accounts="account_list"
      ref="replyEmailModal"
    ></ReplyEmailModal>
    <ForwardEmailModal
      :accounts="account_list"
      ref="forwardSingleModal"
    ></ForwardEmailModal>
    <ForwardEmailModalOneEmail
      :accounts="account_list"
      ref="forwardModalOne"
    ></ForwardEmailModalOneEmail>
    <ForwardEmailOptionsModal
      ref="forwardOptionsModal"
      @apply="showForwardForm($event)"
    ></ForwardEmailOptionsModal>
    <div class="backdrop"></div>
    <modal-attach-mail @attached="checkUpdateMailDetailInfo" @attached-multi="()=> {checkedEmails = []; checkUpdateMailDetailInfo()}" @close="()=>{mailForAttach = null; multipleMailAttach = false}" v-if="mailForAttach || (multipleMailAttach && checkedEmails.length)" :item="multipleMailAttach ? checkedEmails : mailForAttach"></modal-attach-mail>
    <file-viewer :showNavigationButton="true" :isEdit="false" :files="mailDetailInfo ? mailDetailInfo.files : []" ref="viewFile" v-show="fileWatchUrl"></file-viewer>
  </div>
</template>


<script>
import draggable from 'vuedraggable'
import AccountItem from '@/components/mailbox/sidebar/Account'
import NewMailToast from '@/components/mailbox/sidebar/NewMailModal'
import FolderSettings from '@/components/mailbox/sidebar/FolderSettings'
import MailList from '@/components/mailbox/MailList'
import Pagination from '@/components/mailbox/Pagination'
import mailFilter from '@/components/mailbox/Filter.vue'
import CreateAccountModal from "@/components/mailbox/CreateAccountModal"
import TagsModal from "@/components/mailbox/TagsModal"
import MoveToModal from "@/components/mailbox/MoveToModal"
import splitPane from 'vue-splitpane'
import TextModal from "@/components/mailbox/TextModal"
import CreateEmailModal from "@/components/mailbox/CreateEmailModal"
import ReplyEmailModal from "@/components/mailbox/ReplyEmailModal"
import ForwardEmailModal from "@/components/mailbox/ForwardEmailModal"
import ForwardEmailModalOneEmail from "@/components/mailbox/ForwardEmailModalOneEmail"
import ForwardEmailOptionsModal from "@/components/mailbox/ForwardEmailOptionsModal"
import EditNameAccountModal from "@/components/mailbox/EditNameAccountModal"
import SvgSprite from '@/components/mailbox/SvgSprite'
import { mapActions, mapMutations } from "vuex";
import MytestMixin from '@/mixins/mailboxMixins/test.js'
import mailboxAttachMailMixin from '@/mixins/mailboxMixins/mailboxAttachMailMixin'
import MessageHistory from "@/components/mailbox/MessageHistory"
import Signature from "@/components/mailbox/Signature"
import UploadEml from "@/components/mailbox/sidebar/UploadEml"
import mailboxMixinDragAndDropMails from '@/mixins/mailboxMixins/mailboxMixinDragAndDropMails'
import mailboxMixinSwithMessageByKeyUpAndDown from '@/mixins/mailboxMixins/mailboxMixinSwithMessageByKeyUpAndDown'
import DraftDetail from "@/components/mailbox/draft/DraftDetail"



import moment from 'moment'
import ModalAttachMail from "@/components/mailbox/modalAttachMail.vue";
// import MailboxDetailDraft from "@/components/mailbox/mailbox-detail-draft.vue";
import FileViewer from "@/components/counterparties/counterpartiesUser/fileViewer.vue";
import axios from "axios";
  export default {
    components: {
      FileViewer,
      // MailboxDetailDraft,
      DraftDetail,
      MessageHistory, ModalAttachMail, SvgSprite, draggable, AccountItem, mailFilter, CreateAccountModal, MailList, splitPane, MoveToModal, TagsModal, TextModal, EditNameAccountModal, NewMailToast, FolderSettings, CreateEmailModal, Pagination, ReplyEmailModal, ForwardEmailModal, UploadEml, Signature, ForwardEmailModalOneEmail, ForwardEmailOptionsModal},
    mixins: [MytestMixin, mailboxAttachMailMixin, mailboxMixinDragAndDropMails, mailboxMixinSwithMessageByKeyUpAndDown],
    data: () => ({
      account_list: [],
      mailsList: [],
      activeFolder: null,
      activeFolderName: null,
      activeAccount: null,
      mailDetailInfo: null,
      mailsListType: '',
      client: null,
      pageIsBlocked: false,
      mailDetailLoader: false,
      mailListLoader: false,
      tagsModalIsVisible: false,
      actionButtonMenuIsVisible: false,
      socket: null,
      connected: false,
      allMailsCount: {
        all_mails_count: 0,
        unread_mails_count: 0
      },
      search: '',
      searchTimer: null,
      filters: {
        name: '',  //template name
        account: {
          id: null,
          name: 'All inboxes'
        },
        email_from: '',
        email_to: '',
        subject: {
          contains: true,
          subject_contains: '',
          subject_not_contains: '',
        },
        text: {
          contains: true,
          text_contains: '',
          text_not_contains: '',
        },
        subject_choice: 'or', //or and
        text_choice: 'or', //or and
        date: {
          date_after: null,
          date_before: null
        },
        // date: [null, null],
        tags: [],
        has_files: false,
        status: 'all', // all, unread, read,
        hasActiveFilters: false
      },
      filterTemplates: [],
      checkedEmails: [],
      mailIsRead: false,
      pagination: {
        limit: 50,
        offset: 0,
        count: 0,
        next: null,
        previous: null
      },
      orderinCreatedAt: false,
      showFoldersIds: [],
      fileWatchUrl: null,
      draftUpdateTimeout: null
    }),
    provide(){
      return {
        logoutMailAccount: this.deleteAccount,
        updAccountName: this.updateName,
        getMailDetail: this.getMailDetailInfo,
        setActiveFolder: this.setActiveFolder,
        showFolderSettings: this.showFolderSettings,
        updateMails: this.getAccounts,
        clearFilterFields: this.clearFilterFields,
        deleteFolder: this.deleteFolder,
        uploadLetter: this.uploadLetter
      }
    },
    methods: {
      ...mapActions([
        "axiosGetMailboxAccounts",
        "axiosLogoutMailboxAccount",
        "axiosGetAllEmailsCountMailbox",
        "axiosUpdateNameMailboxAccount",
        "axiosUpdateSignatureMailboxAccount",
        "axiosGetMailboxEmails",
        "axiosGetMailboxEmailDetail",
        "axiosGetMailboxEmailDelTag",
        "axiosGetMailboxFilterTemplatesAll",
        "axiosCreateMailboxFilterTemplate",
        "axiosGetSingleMailboxFilterTemplate",
        "axiosChangeMailboxFilterTemplate",
        "axiosDeleteMailboxFilterTemplate",
        "axiosGetMailboxTags",
        "axiosUpdateMailboxEmailItem",
        "axiosMailboxDownloadEmails",
        "axiosMailboxCreateFolder",
        "axiosMailboxUpdateFolder",
        "axiosDeleteMailboxEmailItem",
        "axiosMailboxDeleteFolder",
        "axiosMailboxRemoveTagFromEmail",
        "axiosGetMailboxSignature"
      ]),
      ...mapMutations(["showLoad", "hideLoad", "setMailNotificationDot"]),
      openFile(file, index) {
        this.fileWatchUrl = file;
        setTimeout(()=> {
          this.$refs.viewFile.showViewFileModal(index)
        }, 100)
      },
      showFolderEmit(id) {
        console.log('showFolderEmit')
        if(this.showFoldersIds.indexOf(id) >= 0) {
          this.showFoldersIds = this.showFoldersIds.filter(a=> a != id)
        } else {
          this.showFoldersIds.push(id)
        }
      },
      hideActionButtonsMenu(){
        if(this.actionButtonMenuIsVisible) this.actionButtonMenuIsVisible = false
      },
      changeListType(type){
        this.mailsListType = type;
        this.checkedEmails = []
        this.search = ''
        this.resetPagination()
        this.getMails()
      },
      createGoogleAuthUrl(data){
        const currentUser = JSON.parse(localStorage.getItem("userData"));
        const stateData = {
            name: data.name,
            user_id: currentUser.data.user.id,
        };
        if(data.start_parse_date){
          stateData.start_parse_date = data.start_parse_date
        }
        // const CLIENT_ID = '931959240353-ium7bu1cdsufl5pdk4g0cvb13ksumrms.apps.googleusercontent.com';
        const CLIENT_ID = process.env.VUE_APP_CLIENT_ID_MAILBOX
        let REDIRECT_URI = process.env.VUE_APP_URL_SIMPLE + '/api/mailbox/google/callback/';
        // if(process.env.NODE_ENV == 'development'){
        //   REDIRECT_URI = 'https://dev.speed-logistic-marine.com:8443/api/mailbox/google/callback/'; // редирект на дев
        // }else{
        //   REDIRECT_URI = 'https://speed-logistic-marine.com:8443/api/mailbox/google/callback/'; //редирект на прод
        // }
        
        
        const SCOPES = 'https://mail.google.com/ https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/cloud-platform.read-only https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.modify openid https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/pubsub https://www.googleapis.com/auth/cloud-platform';

        return `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=${SCOPES}&access_type=offline&prompt=consent&state=${encodeURIComponent(JSON.stringify(stateData))}`;
      },
      async createAccount(data){
        window.location.href = this.createGoogleAuthUrl(data);
      },
      downloadFile(file) {
        axios.get(file.file, { responseType: 'blob' })
            .then(response => {
              console.log(response)
              const blob = new Blob([response.data], { type: 'application/plain' })
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = file.name;
              link.click()
              URL.revokeObjectURL(link.href)
            }).catch(console.error)
      },
      updateName(data){
        this.showLoad()
        this.axiosUpdateNameMailboxAccount(data)
        .then(() => {
          this.account_list.find(account => account.id == data.id).name = data.name
          this.hideLoad()
        })
        .catch(err => {
          console.log('err::: ', err);
          this.hideLoad()
        })
      },
      updateSignature(data){
        // console.log('data::: ', data);
        if(data.content){
          let currentAccount = this.account_list.find(account => account.id == data.id)
          if(currentAccount) currentAccount.signature = {id: data.signature, content: data.content, top_content: data.top_content}
        }else{
          let currentAccount = this.account_list.find(account => account.id == data.id)
          if(currentAccount) currentAccount.signature = null
        }
        this.showLoad()
        this.axiosUpdateSignatureMailboxAccount(data)
        .then(() => {
          // this.account_list.find(account => account.id == data.id).name = data.name
          // this.getAccounts()
          this.hideLoad()
        })
        .catch(err => {
          console.log('err::: ', err);
          this.hideLoad()
        })
      },
      blockPage(){
        this.pageIsBlocked = true;
      },
      getAllMailsCount(){
        this.axiosGetAllEmailsCountMailbox()
        .then(response => {
          this.allMailsCount = response.data
        })
        .catch(err => {
          console.log('err::: ', err);
        })
        
      },
      setActiveFolder(id, folderName = null){
        this.activeFolderName = folderName
        this.activeAccount = null
        id ? this.activeFolder = id : this.activeFolder = null
        this.mailDetailInfo = null
        this.checkedEmails = []
        this.search = ''
        this.resetPagination()
        this.getMails()
      },
      setActiveAccountInfo(id){
        this.activeAccount = id;
        this.activeFolder = null;
      },
      async getMails(){
        // this.showLoad()
        
        this.mailListLoader = true;
        let data = {
          search: this.search,
          limit: this.pagination.limit,
          offset: this.pagination.offset,
          ordering: this.orderinCreatedAt ? 'created_at' : '-created_at'
        }
        if(this.mailsListType != ''){
          this.mailsListType == 'is_read' ? data[this.mailsListType] = false : (this.mailsListType == 'read' ? data['is_read'] = true : data[this.mailsListType] = true)
        }
        if(this.filters.hasActiveFilters) {
          let filters = await this.getFilters();
          data = {...data, ...filters}
        }
        if(this.activeFolder){
          data.folder = this.activeFolder
        }else{
          data.only_inboxes = true
        }
        this.axiosGetMailboxEmails(data)
        .then(response => {
          
          this.pagination.count = response.data.count
          this.pagination.next = response.data.next
          this.pagination.previous = response.data.previous
          
          this.mailsList = response.data.results;
          // this.hideLoad()
          this.mailListLoader = false;
        })
        .then(async () => {
          await this.$nextTick()
          if(this.$refs.mailsTable){
            this.$refs.mailsTable.createTable()
          }else{
            document.querySelectorAll('.grip-container').forEach(
              emptyTable => emptyTable.remove()
            );
          }
          
        })
        .catch( err => {
          console.log('err::: ', err);
          // this.hideLoad()
          this.mailListLoader = false;

        })
      },
      getFiltersTemplates(){
        this.axiosGetMailboxFilterTemplatesAll()
        .then(response => {
          this.filterTemplates = response.data
          this.sortTemplates()
        })
      },
      getAccounts(bool){
        // this.showLoad()
        // console.log('getAccounts::: ');
        this.mailListLoader = true;
        this.account_list = []
        this.axiosGetMailboxAccounts()
        .then(response => {
          if(response.data.length == 0){
            this.blockPage()
          }
          this.account_list = response.data
          // this.hideLoad()
          this.mailListLoader = false;
        })
        .then(() => {
          if(this.account_list.length != 0){
            this.getMails()
            this.getFiltersTemplates()
          }
          if(bool) {
            this.hideLoad()
          }
        })
        .catch(err => {
          console.log('err::: ', err);
          // this.hideLoad()
          this.mailListLoader = false;
        })
        this.getAllMailsCount()
      },
      updateFolders(){
        this.axiosGetMailboxAccounts()
        .then(response => {
          this.account_list = response.data
          this.getAllMailsCount()
        })
      },
      deleteAccount(accountId){
        this.showLoad()
        this.axiosLogoutMailboxAccount(accountId)
        .then(() => {
          this.mailsList = []
          this.activeAccount = null
          this.hideLoad()
          this.getAccounts()
        })
        .catch(err => {
          console.log('err::: ', err);
          this.hideLoad()
        })
      },
      
      removeStyles(html){
        // С бэкэнда прилетает письмо в виде html, иногда со стилями которые ломают страницу. Очистить письмо от стилей:
        const container = document.createElement('div');
        container.innerHTML = html;
        container.querySelectorAll('meta').forEach(
          meta => meta.remove()
        );
        container.querySelectorAll('style').forEach(
          style => style.remove()
        );
        return container.innerHTML;
      },
      getMailDetailInfo(emailID, folderID, scrollTop){
        this.mailDetailLoader = true;
        this.axiosGetMailboxEmailDetail(emailID)
        .then(async response => {
          this.mailDetailInfo = response.data;
          this.mailDetailInfo.text = this.removeStyles(this.mailDetailInfo.text)
          this.mailDetailLoader = false;
          let mailItem = this.mailsList.find(mail => mail.id == emailID);
          
          // Если письмо не прочитано, "прочитать его" и изменить счетчик непрочитанных сообщений в сайдбаре и папках
          if(!mailItem.is_read){
            mailItem.is_read = true
            this.mailIsRead = false
            this.updateFolders()
            // this.account_list.find(account => {
            //   return account.folders.find(folder => folder.id == folderID).unread_mails_count--
            // }).unread_mails_count--
            // this.allMailsCount.unread_mails_count--
          }
          if(scrollTop) {
            await this.$nextTick()
            let element = document.querySelector('.splitter-pane')
            let activeElement = document.querySelector('.table-row.active')
            console.dir(activeElement)
            element.scrollTop = activeElement.offsetTop - activeElement.clientHeight - 5
          }
        })
        .then(() => {
          let emailsList = document.querySelectorAll('.text-block_accordeon .text-block__item')
          emailsList.forEach(el => {
            if( el.scrollWidth <= el.clientWidth){
              el.closest('.text-block_accordeon').classList.remove('text-block_accordeon')
            }
          })
        })
        .catch(err => {
          console.log('err::: ', err);
          this.mailDetailLoader = false;

        })
      },
      updateMailDetailInfo(){
        if(this.mailDetailInfo){
          this.mailDetailLoader = true;
          this.axiosGetMailboxEmailDetail(this.mailDetailInfo.id)
          .then(response => {
            this.mailDetailInfo = response.data;
            this.mailDetailInfo.text = this.removeStyles(this.mailDetailInfo.text)
            this.mailDetailLoader = false;
          })
          .catch(err => {
            console.log('err::: ', err);
            this.mailDetailLoader = false;

          })
        }
      },
      deleteTag(tagID, mailID){
        let currentEmail = this.mailsList.find(mail => mail.id == mailID)
        if(currentEmail){
          currentEmail.tags = currentEmail.tags.filter(tag => tag.id != tagID)
          this.mailDetailInfo.tags = this.mailDetailInfo.tags.filter(tag => tag.id != tagID)
          this.axiosMailboxRemoveTagFromEmail({
            mailId: mailID,
            info: {
              tags_id: [tagID]
            }
          }).catch(err => console.log('err del tag', err))
        }
      },
      setFilters(){
        // Отследить активные фильтры и разукрасить кнопку синим
        if(this.filters.account.id || 
        this.filters.date.date_after || 
        this.filters.date.date_before || 
        this.filters.email_from || 
        this.filters.email_to || 
        this.filters.has_files || 
        this.filters.status == 'unread' || 
        this.filters.status == 'read' || 
        this.filters.subject.subject_contains || 
        this.filters.text.text_contains || 
        this.filters.tags.length != 0){
          this.filters.hasActiveFilters = true
        }else{
          this.filters.hasActiveFilters = false
        }
        this.getMails()
      },
      clearFilters(){
        this.filters.account = {id: null, name: 'All inboxes'}
        this.filters.email_from = ''
        this.filters.email_to = ''
        this.filters.subject.contains = true
        this.filters.subject.subject_contains = ''
        this.filters.subject.subject_not_contains = ''
        this.filters.text.contains = true
        this.filters.text.text_contains = ''
        this.filters.text.text_not_contains = ''
        this.filters.subject_choice = 'or'
        this.filters.text_choice = 'or'
        this.filters.date.date_after = null
        this.filters.date.date_before = null
        this.filters.tags = []
        this.filters.has_files = false
        this.filters.status = 'all'
        this.filters.hasActiveFilters = false
        this.getMails()
      },
      clearFilterFields(){
        this.filters.account = {id: null, name: 'All inboxes'}
        this.filters.email_from = ''
        this.filters.email_to = ''
        this.filters.subject.contains = true
        this.filters.subject.subject_contains = ''
        this.filters.subject.subject_not_contains = ''
        this.filters.text.contains = true
        this.filters.text.text_contains = ''
        this.filters.text.text_not_contains = ''
        this.filters.subject_choice = 'or'
        this.filters.text_choice = 'or'
        this.filters.date.date_after = null
        this.filters.date.date_before = null
        this.filters.tags = []
        this.filters.has_files = false
        this.filters.status = 'all'
        this.filters.hasActiveFilters = false
      },
      getFilters(){
        let activeFilters = {};
        activeFilters.text_choice = this.filters.text_choice
        activeFilters.subject_choice = this.filters.subject_choice
        if(this.filters.account.id) activeFilters.account = [this.filters.account.id]
        if(this.filters.email_from){
          // activeFilters.email_from = this.filters.email_from.split(',').filter(el => el != ' ' &&  el != '')
          // activeFilters.email_from = activeFilters.email_from.map(str => str.trim())
          // console.log('this.filters.email_from.split(',')::: ', this.filters.email_from.split(',').map(str => str.trim()).filter(el => el != ' ' &&  el != ''));
          // Удалить все лишние пробелы
          activeFilters.email_from = this.filters.email_from.split(',').map(str => str.trim()).filter(el => el != ' ' &&  el != '')
        }
        if(this.filters.email_to){
          // activeFilters.email_to = this.filters.email_to.split(',').filter(el => el != ' ' &&  el != '')
          // activeFilters.email_to = activeFilters.email_to.map(str => str.trim())
          // Удалить все лишние пробелы
          activeFilters.email_to = this.filters.email_to.split(',').map(str => str.trim()).filter(el => el != ' ' &&  el != '')
        }
        if(this.filters.subject.subject_contains){
          if(this.filters.subject.contains){
            activeFilters.subject_contains = this.filters.subject.subject_contains
          }else{
            activeFilters.subject_not_contains = this.filters.subject.subject_not_contains
          }
        }
        if(this.filters.text.text_contains){
          if(this.filters.text.contains){
            activeFilters.text_contains = this.filters.text.text_contains
          }else{
            activeFilters.text_not_contains = this.filters.text.text_not_contains
          }
        }
        if(this.filters.date.date_after){
          activeFilters.date_after = moment(this.filters.date.date_after).format('YYYY-MM-DD')
          activeFilters.date_before = moment(this.filters.date.date_before).format('YYYY-MM-DD')
        }
        if(this.filters.has_files) activeFilters.has_files = this.filters.has_files
        if(this.filters.status == 'unread') activeFilters.is_read = false
        if(this.filters.status == 'read') activeFilters.is_read = true
        if(this.filters.tags.length != 0){
          activeFilters.tags = this.filters.tags.map(tag => tag.id)
        }
        return activeFilters
      },
      async createFilterTemplate(){
        let data = await this.getFilters()
        data.name = `Filter template`
        if(typeof data.is_read != 'undefined'){
          data.is_read ? data.status = 'read' : data.status = 'unread'
          delete data.is_read
        }
        if(data.subject_contains){
          data.subject = data.subject_contains
          this.filters.subject.contains ? data.subject_type = 'contains' : data.subject_type = 'not_contains'
          delete data.subject_contains
        }
        if(data.subject_not_contains){
          data.subject = data.subject_not_contains
          this.filters.subject.contains ? data.subject_type = 'contains' : data.subject_type = 'not_contains'
          delete data.subject_not_contains
        }
        if(data.text_contains){
          data.subject = data.text_contains
          this.filters.text.contains ? data.text_type = 'contains' : data.text_type = 'not_contains'
          delete data.text_contains
        }
        if(data.text_not_contains){
          data.subject = data.text_not_contains
          this.filters.text.contains ? data.text_type = 'contains' : data.text_type = 'not_contains'
          delete data.text_not_contains
        }
        console.log('data::: ', data);
        this.axiosCreateMailboxFilterTemplate(data)
        .then(response => {
          let template = response.data;
          template.readonly = false;
          this.filterTemplates.push(response.data)
          this.sortTemplates()
          this.$refs.mailFilter.setActiveTemplate(template.id)
        })
      },
      changeFilterTemplateName(id){
        let template = this.filterTemplates.find(template => template.id == id);
        template.readonly = true;
        let data = {
          id: id,
          info: template
        }
        this.axiosChangeMailboxFilterTemplate(data)
        .then(() => {
          this.sortTemplates()
        })
      },
      deleteFilterTemplate(id){
        this.axiosDeleteMailboxFilterTemplate(id)
        .then(() => {
          this.filterTemplates = this.filterTemplates.filter(template => template.id != id)
          this.sortTemplates()
        })
      },
      sortTemplates(){
        if(this.filterTemplates.length != 0){
          let defaultTemplates = []
          let customTemplates = []
          this.filterTemplates.forEach(template => {
            if(template.name.includes('Filter template')){
              defaultTemplates.push(template) 
            }else{
              customTemplates.push(template)
            }
          })
          customTemplates.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
          })
          this.filterTemplates = [...customTemplates, ...defaultTemplates]

        }
      },
      getTemlateFilterList(id){
        return new Promise((resolve, reject) => {
          this.axiosGetSingleMailboxFilterTemplate(id)
          .then(response => {
            this.filters.name = response.data.name
            if(response.data.account.length != 0){
              this.filters.account = this.account_list.find(account => account.id == response.data.account[0]) 
            }
            if(response.data.date_after){
              this.filters.date.date_after = new Date(response.data.date_after)
              this.filters.date.date_before = new Date(response.data.date_before)
            }else{
              this.filters.date.date_after = response.data.date_after
              this.filters.date.date_before = response.data.date_before
            }
            
            if(response.data.email_from){
              this.filters.email_from = response.data.email_from.join(', ') + ','
            }
            if(response.data.email_to){
              this.filters.email_to = response.data.email_to.join(', ') + ','
            }
            if(response.data.subject){
              this.filters.subject.subject_contains = response.data.subject
              this.filters.subject.subject_not_contains = response.data.subject
            }
            this.filters.subject.contains = response.data.subject_type == "contains"
            if(response.data.text){
              this.filters.text.text_contains = response.data.text
              this.filters.text.text_not_contains = response.data.text
            }
            this.filters.text.contains = response.data.text_type == "contains"
            this.filters.subject_choice = response.data.subject_choice
            this.filters.text_choice = response.data.text_choice
            // this.filters.tags = response.data.tags
            
            this.filters.status = response.data.status
            this.filters.has_files = !!response.data.has_files
            this.filters.hasActiveFilters = true
            this.mailListLoader = false;
            if(response.data.tags.length != 0){
              this.axiosGetMailboxTags()
              .then(responseTagsList => {
                this.filters.tags = response.data.tags.map(tagId => {
                  return responseTagsList.data.results.find(tag => tag.id == tagId)
                })
              })
              .then(() => {
                resolve()
              })
            }else{
              resolve()
            }
          })
          .catch(err => {
            reject(err)
          })
        })
      },
      applyTemplate(id){
        this.mailListLoader = true;
        this.getTemlateFilterList(id)
        .then(() => {
          this.getMails()
        })
      },
      editTemplate(id){
        this.clearFilterFields()
        this.getTemlateFilterList(id)
        .then(() => {
          this.$refs.mailFilter.showEditTemplate()
        })
      },
      async saveFilterTemplate(){
        let data = await this.getFilters()
        data.name = this.filters.name
        if(typeof data.is_read != 'undefined'){
          data.is_read ? data.status = 'read' : data.status = 'unread'
          delete data.is_read
        }
        if(data.subject_contains){
          data.subject = data.subject_contains
          this.filters.subject.contains ? data.subject_type = 'contains' : data.subject_type = 'not_contains'
          delete data.subject_contains
        }
        if(data.subject_not_contains){
          data.subject = data.subject_not_contains
          this.filters.subject.contains ? data.subject_type = 'contains' : data.subject_type = 'not_contains'
          delete data.subject_not_contains
        }
        if(data.text_contains){
          data.subject = data.text_contains
          this.filters.text.contains ? data.text_type = 'contains' : data.text_type = 'not_contains'
          delete data.text_contains
        }
        if(data.text_not_contains){
          data.subject = data.text_not_contains
          this.filters.text.contains ? data.text_type = 'contains' : data.text_type = 'not_contains'
          delete data.text_not_contains
        }
        
        let requestData = {
          id: this.$refs.mailFilter.activeTemplate,
          info: data
        }

        this.axiosChangeMailboxFilterTemplate(requestData)
        .then(() => {
          this.applyTemplate(this.$refs.mailFilter.activeTemplate)
          this.$refs.mailFilter.hideFilter()
        })

        
      },
      // mail items actions
      updateMailItem(data){
        console.log('data::: ', data);
        data.ids.forEach(mailID => {
          let mail = this.mailsList.find(mailItem => mailItem.id == mailID)
          mail.is_important = data.is_important
          mail.is_read = data.is_read
          mail.tags = data.tags
          mail.folder = data.folder
        })
        data.tags = data.tags.map(tag => tag.id)

        this.axiosUpdateMailboxEmailItem(data)
        
      },
      addToImportant(){
        let data = {}
        let is_important = null;
        let isImportantItems = [];
        let isNoImportantItems = [];
        if(this.isCheckedEmails){
          data = {
            ids: this.checkedEmails
          }
          
        }else{
          data = {
            ids: [this.mailDetailInfo.id]
          }
        }
        data.ids.forEach(mailID => {
          let mail = this.mailsList.find(mailItem => mailItem.id == mailID)
          if(mail.is_important){
            isImportantItems.push(mail)
          }else{
            isNoImportantItems.push(mail)
          }
        })
        // Если есть письма со звездочкой и без нее или все письма без звездочки, то отметить звездой все
        if((isImportantItems.length != 0 && isNoImportantItems.length != 0) || 
           (isImportantItems.length == 0 && isNoImportantItems.length != 0)){

            is_important = true;
            isNoImportantItems.forEach(mail => mail.is_important = is_important)
        }

        // Если все письма со звездочкой, то убрать ее у всех
        if(isImportantItems.length != 0 && isNoImportantItems.length == 0){

          is_important = false;
          isImportantItems.forEach(mail => mail.is_important = is_important)
        }

        data.is_important = is_important
        this.axiosUpdateMailboxEmailItem(data)
      },
      addToUnread(mail = null){
        // mail - письмо в котором использовали action menu
        // let data = {}
        // if(!mail){
        //   if(this.isCheckedEmails){
        //     data = {
        //       ids: this.checkedEmails,
        //       is_read: false
        //     }
        //   }else{
        //     data = {
        //       ids: [this.mailDetailInfo.id],
        //       is_read: false
        //     }
        //   }
        // }else{
        //   data = {
        //     ids:  [mail.id],
        //     is_read: !mail.is_read
        //   }
        // }

        // data.ids.forEach(mailID => {
        //   this.mailsList.find(mailItem => mailItem.id == mailID).is_read = false
        // })

        // ---------------------
        let data = {}
        let is_read = null;
        let isReadItems = [];
        let isUnreadItems = [];
        if(!mail){

          if(this.isCheckedEmails){
            data = {
              ids: this.checkedEmails
            }
          }else{
            data = {
              ids: [this.mailDetailInfo.id]
            }
          }
  
          data.ids.forEach(mailID => {
            let mail = this.mailsList.find(mailItem => mailItem.id == mailID)
            if(mail.is_read){
              isReadItems.push(mail)
            }else{
              isUnreadItems.push(mail)
            }
          })
  
           // Если есть прочитанные и не прочитанные письма , то прочитать все
          if((isReadItems.length != 0 && isUnreadItems.length != 0) || 
             (isReadItems.length == 0 && isUnreadItems.length != 0)){
              is_read = true;
              isUnreadItems.forEach(mail => mail.is_read = is_read)
          }
  
          // Если все письма прочитаны, то "непрочитать" все
          if(isReadItems.length != 0 && isUnreadItems.length == 0){
            is_read = false;
            isReadItems.forEach(mail => mail.is_read = is_read)
          }
          data.is_read = is_read
          this.mailIsRead = !is_read
        }else{
          data = {
            ids:  [mail.id],
            is_read: !mail.is_read
          }
        }


        this.axiosUpdateMailboxEmailItem(data)
        .then(() => {
          this.getAccounts()
        })
      },
      checkMailItem(id){
        if(this.checkedEmails.includes(id)){
          this.checkedEmails = this.checkedEmails.filter(checkedID => checkedID != id)
        }else{
          this.checkedEmails.push(id)
        }
      },
      checkAllEmails(){
        if(this.checkedEmails.length == this.mailsList.length){
          this.checkedEmails = []
        }else{
          this.checkedEmails = this.mailsList.map(mail => mail.id)
        }
      },
      downloadEmails(mail = null){
        // mail - письмо в котором использовали action menu
        let data = {}
        if(!mail){
          if(this.isCheckedEmails){
            data = {
              ids: this.checkedEmails.map(id => this.mailsList.find(mail => mail.id == id).message_id),
            }
          }else{
            data = {
              ids: [this.mailDetailInfo.message_id]
            }
          }
        }else{
          data = {
            ids: [mail.message_id]
          }
        }
        this.axiosMailboxDownloadEmails(data)
        .then(response => {
          let link = document.createElement('a')

          if(response.headers['content-type'] == "application/zip"){
            let url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
            link.href = url;
            link.setAttribute("download", "emails.zip");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }else{
            let url = window.URL.createObjectURL(new Blob([response.data]));
            link.href = url;
            link.setAttribute("download", "subject.eml");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(err => {
          console.log('axiosMailboxDownloadEmails err::: ', err);
        })
      },
      moveToSpam(mail = null, to_spam = true){
        let data = {}
        // mail - письмо в котором использовали action menu
        if(!mail){
          if(this.isCheckedEmails){
            data = {
              ids: this.checkedEmails,
              to_spam: to_spam
            }
          }else{
            data = {
              ids: [this.mailDetailInfo.id],
              to_spam: to_spam
            }
          }
        }else{
          data = {
            ids: [mail.id],
            to_spam: to_spam
          }
        }
        this.axiosUpdateMailboxEmailItem(data)
        .then(() => {
          this.getAccounts()
          this.checkedEmails = []
          this.mailDetailInfo = null
        })
      },
      moveToArchive(mail = null, to_archive = true){
        // mail - письмо в котором использовали action menu
        let data = {}
        if(!mail){
          if(this.isCheckedEmails){
            data = {
              ids: this.checkedEmails,
              to_archive: to_archive
            }
          }else{
            data = {
              ids: [this.mailDetailInfo.id],
              to_archive: to_archive
            }
          }
        }else{
          data = {
            ids: [mail.id],
            to_archive: to_archive
          }
        }
        this.axiosUpdateMailboxEmailItem(data)
        .then(() => {
          this.getAccounts()
          this.checkedEmails = []
          this.mailDetailInfo = null
        })
      },
      mailMenuAction(actionInfo){
        if(actionInfo.actionName == "makeUnread"){
          this.addToUnread({id: actionInfo.info.id, is_read: actionInfo.info.is_read})
        }
        if(actionInfo.actionName == "toArchive"){
          this.moveToArchive({id: actionInfo.info.id})
        }
        if(actionInfo.actionName == "download"){
          this.downloadEmails(actionInfo.info)
        }
        if(actionInfo.actionName == "moveToFolder"){
          this.showMoveToModal(actionInfo.info.id, actionInfo.info.account_id)
        }
        if(actionInfo.actionName == "unarchive"){
          this.moveToArchive({id: actionInfo.info.id}, false)
        }
        if(actionInfo.actionName == "notSpam"){
          this.moveToSpam({id: actionInfo.info.id}, false)
        }
        if(actionInfo.actionName == "deleteForever"){
          this.deleteForever({id: actionInfo.info.id})
        }
        if(actionInfo.actionName == "attachTo"){
          this.setIdMailForAttach(actionInfo.info) // mailboxAttachMailMixin
        }
      },
      showMoveToModal(mailId = null, accountId = null){
        if(!mailId){
          if(this.isCheckedEmails){
            this.$refs.moveToModal.showModal(this.checkedEmails, this.isFromDifferentAccounts)
          }else{
            this.$refs.moveToModal.showModal([this.mailDetailInfo.id], [this.mailDetailInfo.account_id])
          }
        }else{
          this.$refs.moveToModal.showModal([mailId], [accountId])
        }
      },
      moveToFolder(moveInfo){
        let data  = {
          ids: moveInfo.mailsId,
          folder: moveInfo.folderId,
          duplicate_in_inbox: false
        }
      
        this.axiosUpdateMailboxEmailItem(data)
        .then(() => {
          this.$refs.moveToModal.hideModal()
          this.getAccounts()
          this.checkedEmails = []
          this.mailDetailInfo = null
        })

      },
      deleteFolder(folderId){
        this.axiosMailboxDeleteFolder(folderId)
        .then(() => {
          this.getAccounts()
        })
        .catch(err => {
          console.log('err::: ', err);
        })
      },
      showTagsModal(){
        setTimeout(() => {
          if(!this.$refs.tagsModal.show){
            this.$refs.tagsModal.showModal()
          }
        }, 100)
      },
      addTagsToMail(tags){
        let data = {}
        if(this.isCheckedEmails){
          data = {
            ids: this.checkedEmails,
            tags: tags
          }
        }else{
          data = {
            ids: [this.mailDetailInfo.id],
            tags: tags
          }
        }
        
        this.axiosUpdateMailboxEmailItem(data)
        .then(() => {
          // this.getAccounts()
          this.getMails()
          this.updateMailDetailInfo()
        })
      },
      connectSocked() {
        let url = 'wss://'+process.env.VUE_APP_URL_SOCKET+'/'
        this.socket = new WebSocket(url);
      },
      addMailFromSocket(mail){
        if(mail.all_message_count){
          // console.log('addMailFromSocket::: ', mail);
          this.$refs.mailToast.showToast(mail, null)
          // this.$refs.mailToast.showToast(
          //   {
          //     index: mail.index,
          //     all_message_count: mail.all_message_count,
          //   }, null)
          // Если загружены все письма актуализировать кол-во в сайдбаре
          if(mail.all_message_count == mail.index) this.updateFolders()
        }else if(mail.is_need_bell){
          this.$refs.mailToast.showToast(null, {
            mailId: mail.id,
            folderId: mail.folder.id
          })
        }
        // Аккаунт в который пришло письмо
        let currentAccount = this.account_list.find(account => account.id == mail.account_id);
        let currentFolder = null;
        if(currentAccount){
          currentFolder = currentAccount.folders.find(folder => {
            if(folder.id == mail.folder.id){
              return folder
            }else if(Array.isArray(folder.child_folders)){
              return folder.child_folders.find(childFolder => childFolder.id == mail.folder.id)
            }else{
              return null
            }
          })
          
          // Добавить +1 к аккаунту в сайдбаре
          currentAccount.mails_count++
          // Добавить +1 к аккаунту в сайдбаре "не прочитано"
          if(!mail.is_read) currentAccount.unread_mails_count++
        }
        
        if(currentFolder){
          // Добавить +1 письмо в сайдбаре у актуальной папки
          currentFolder.mails_count = mail.folder.mails_count
          currentFolder.unread_mails_count = mail.folder.unread_mails_count
        }

        if(mail.folder.title == "Incoming"){
          // Добавить +1 к All inboxes в сайдбаре
          this.allMailsCount.all_mails_count++
          // Добавить +1 к All inboxes в сайдбаре "не прочитано"
          if(!mail.is_read) this.allMailsCount.unread_mails_count++
        }

        // Update drafts
        if(this.draftUpdateTimeout){
          clearTimeout(this.draftUpdateTimeout);
          this.updateDraftMails()
          this.draftUpdateTimeout = null
        }

        // Если выбрано All inboxes и письмо из входящих - добавить в общий список
        if(!this.activeAccount && !this.activeFolder && mail.folder.title == "Incoming" && this.pagination.offset == 0){
          this.mailsList.unshift(mail)
          return
        }

        if(this.activeFolder == mail.folder.id && this.pagination.offset == 0){
          // Если выбрана какая-то папка, добавить письмо в общий список
          this.mailsList.unshift(mail)
          return
        }
        
      },
      showFolderSettings(folderInfo, isCreated = true){
        console.log('folderInfo::: ', folderInfo);
        this.$refs.folderSettingsMenu.showsettingsMenu(folderInfo, isCreated)
      },
      createFolder(data){
        // console.log('data::: ', data);
        this.axiosMailboxCreateFolder(data)
        .then(() => {
          this.getAccounts()
        })
      },
      saveFolder(data){
        console.log('data::: ', data);
        this.axiosMailboxUpdateFolder(data)
        .then(() => {
          this.getAccounts()
        })
      },
      openInNewWindow() {
        var windowFeatures = 'width=' + 1000 + ',height=' + 600;

        window.open(window.location.href+'/?hideNavigation', '_blank', windowFeatures);
      },
      deleteForever(mail = null){
        let data = {}
        // mail - письмо в котором использовали action menu
        if(!mail){
          if(this.isCheckedEmails){
            data = {
              ids: this.checkedEmails,
              from_draft: this.activeFolderName == 'Draft' ? true : false
            }
          }else{
            data = {
              ids: [this.mailDetailInfo.id],
              from_draft: this.activeFolderName == 'Draft' ? true : false
            }
          }
        }else{
          data = {
            ids: [mail.id],
            from_draft: this.activeFolderName == 'Draft' ? true : false
          }
        }
        this.axiosDeleteMailboxEmailItem(data)
        .then(() => {
          this.getAccounts()
          this.checkedEmails = []
          this.mailDetailInfo = null
        })
      },
      deleteHistoryItem(messageID){
        let data = {
          ids: [messageID]
        }
        this.axiosDeleteMailboxEmailItem(data)
        .then(() => {
          this.updateMailDetailInfo()
        })
      },
      goPrevPage(){
        if(this.pagination.previous){
          this.pagination.offset -= this.pagination.limit
        }
        this.checkedEmails = []
        this.getMails()
      },
      goNextPage(){
        if((this.pagination.offset + this.pagination.limit) >= this.pagination.count){
          this.pagination.offset = this.pagination.count - this.pagination.limit
        }else{
          this.pagination.offset += this.pagination.limit
        }
        this.checkedEmails = []
        this.getMails()
      },
      showReplyForm() {
        if(this.isCheckedEmails){
          this.$refs.replyEmailModal.showModal(this.checkedEmails)
        }else{
          this.$refs.replyEmailModal.showModal([this.mailDetailInfo.id])
        }
      },
      resetPagination(){
        if(this.pagination.offset != 0){
          this.pagination.offset = 0
          this.pagination.previous = null
        }
      },
      
      showForwardForm(type = null){
        if(type == 'default'){
          this.$refs.forwardSingleModal.showModal(this.checkedEmails)
          return
        }

        if(type == 'allInOne'){
          this.$refs.forwardModalOne.showModal(this.checkedEmails, 'allInOne')
          return
        }

        if(type == 'allInFiles'){
          this.$refs.forwardModalOne.showModal(this.checkedEmails, 'allInFiles')
          return
        }

        if(this.isCheckedEmails){
          if(this.checkedEmails.length == 1){
            this.$refs.forwardSingleModal.showModal(this.checkedEmails)
          }else{
            this.$refs.forwardOptionsModal.showModal()
          }
        }else{
          this.$refs.forwardSingleModal.showModal([this.mailDetailInfo.id])
        }
      },
      uploadLetter(folderId){
        this.$refs.uploadEmlComponent.showUploadForm(folderId)
      },
      toggleHiddenText(e){
        e.target.previousElementSibling.classList.toggle('crop')
        e.target.classList.toggle('show')
      },
      updateDraftMails(){
        this.mailDetailInfo = null
        this.updateFolders()
        this.getMails()
      },
      deleteEmail(mailId){
        this.mailsList = this.mailsList.filter(mail => mail.id != mailId)
      },
      reSaveDraft(mailId){
        this.deleteEmail(mailId)
        this.mailDetailInfo = null
        this.draftUpdateTimeout = setTimeout(() => {
          this.updateDraftMails()
        }, 10000)
      }
    },
    computed: {
      accontsForDropdown(){
        return this.account_list.map(el => {
          return {
            id: el.id,
            name: el.name
          }
        })
      },
      isCheckedEmails(){
        return this.checkedEmails.length != 0
      },
      isDisabledActivityButtons(){
        return this.checkedEmails.length == 0 && !this.mailDetailInfo
      },
      isFromDifferentAccounts(){
        // Заблокировать action кнопки если выбраны письма из разных аккаунтов
        if(this.isCheckedEmails){
          let accoutIDS = this.checkedEmails.map(id => {
            let mail = this.mailsList.find(mail => mail.id == id)
            if(mail){
              return mail.account_id
            }
          })
          return [...new Set(accoutIDS)]
        }else{
          return []
        }
      },
      getAccountInfo(){
        if(this.activeAccount){
          return this.account_list.find(account => account.id == this.activeAccount)
        }else{
          return '-'
        }
      },
      isMarkUnread(){
        let isReadItems = [];
        let isUnreadItems = [];
        let is_read = true
        this.checkedEmails.forEach(mailID => {
          let mail = this.mailsList.find(mailItem => mailItem.id == mailID)
          if(mail){
            if(mail.is_read){
              isReadItems.push(mail)
            }else{
              isUnreadItems.push(mail)
            }
          }
        })

        if((isReadItems.length != 0 && isUnreadItems.length != 0) || 
             (isReadItems.length == 0 && isUnreadItems.length != 0)){
              is_read = true;
          }
  
          // Если все письма прочитаны, то "непрочитать" все
          if(isReadItems.length != 0 && isUnreadItems.length == 0){
            is_read = false;
          }

        return is_read;
      },
      getDraftTextToDetailMail(){
        if(!this.mailDetailInfo){
          return null
        }
        let container = document.createElement('div');
        container.innerHTML = this.mailDetailInfo.text;
        let draftText = container.querySelector('.draft-text')
        if(draftText){
          return draftText.innerHTML
        }else{
          return null
        }
      }
    },
    async mounted(){
      this.getAccounts()
      this.setMailNotificationDot(false)
      this.connectSocked();
      this.socket.onopen = () => {
        this.connected = true;
        console.log('Mail socket connected::: ');
      }
      this.socket.onclose = () => {
        this.connected = false;
        this.connectSocked();
      }
      this.socket.onmessage = (event) => {
        if(JSON.parse(event.data).event_type == 'new_message'){
          const currentUser = JSON.parse(localStorage.getItem("userData"));
          if(currentUser.data.user.id == JSON.parse(event.data).detail.for_user_id){
            this.addMailFromSocket(JSON.parse(event.data).detail)
          }
          console.log('socket mail::: ', JSON.parse(event.data));
        }
      };
      this.axiosGetMailboxSignature()
      console.log('::: Оно живое!');
    },
    watch: {
      orderinCreatedAt: function () {
        this.resetPagination()
        this.getMails()
      },
      search: function () {
        this.resetPagination()
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
          this.getMails()
        }, 500);
      },
      checkedEmails: function(val){
        if(val.length != 0){
          this.mailIsRead = this.isMarkUnread
        }else{
          this.mailIsRead = false
        }
      }
      // filters: {
      //   handler(val){
      //     // Отследить активные фильтры и разукрасить кнопку синим
      //     if(val.account || 
      //       val.date.date_after || 
      //       val.date.date_before || 
      //       val.email_from || 
      //       val.email_to || 
      //       val.has_file || 
      //       val.status == 'unread' || 
      //       val.status == 'read' || 
      //       val.subject.subject_contains || 
      //       val.text.text_contains || 
      //       val.tags.length != 0){
      //         this.filters.hasActiveFilters = true
      //       }else{
      //         this.filters.hasActiveFilters = false
      //       }
      //   },
      //   deep: true
      // }
    },
  }
</script>
<style lang="scss">
#app{
  .rangeGrip{
    // height: 100vh;
    height: 100%;
    width: 1px;
    border-right: 1px dashed var(--color-gray-text);
    opacity: 0;
  }
  .grip-handle{
    &.rangeDrag{
      .rangeGrip{
        opacity: 1;
      }
    }
  }
  .splitter-pane{
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
  .splitter-pane-resizer.horizontal{
    border-top: 5px solid #fff;
    border-bottom: 5px solid #fff;
    opacity: 1;
    background: var(--color-gray-text);
  }
  // .navigation-panel{
  //   z-index: 9999;
  // }
}
</style>
<style lang="scss" scoped>
@import "./src/components/mailbox/styles/default";
@import "./src/components/mailbox/styles/mailsTableStyles";
$spinkit-size: 2em !default;
$spinkit-spinner-color: #319FEF !default;
.sidebar{
  border-right: 1px solid var(--color-gray-text);
  min-width: 320px;
  width: 320px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .heading-block{
    display: flex;
    align-items: center;
    padding: 6px 16px;
    column-gap: 8px;
    border-bottom: 1px solid var(--color-border);
  }
  .sidebar__button{
    border: 1px solid var(--color-blue-dark);
    height: 32px;
    flex-grow: 1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(50% - 4px);
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: var(--color-blue-dark);
    column-gap: 4px;
    transition: .3s;
    svg{
      path{
        transition: .3s;
      }
    }
    &:hover{
      color: var(--color-white);
      border-color: var(--color-white);
      background: var(--color-blue-dark);
      svg{
        path{
          fill: var(--color-white);
        }
      }
    }
    &.blockPage{
      background: var(--color-white);
      z-index: 9999;
      &:hover{
        background: var(--color-blue-dark);
      }
    }
  }
  .all-lists-row{
    padding: 0px 32px 0px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--color-border);
    height: 44px;
    .left-col{
      display: flex;
      align-items: center;
      column-gap: 4px;
      .num{
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        display: flex;
        padding: 2px 6px;
        color: var(--color-white);
        border-radius: 10px;
        background: var(--color-blue);
      }
    }
    .all-lists-btn{
      display: flex;
      align-items: center;
      column-gap: 4px;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      color: var(--color-dark);
      transition: .3s;
      svg{
        path{
          transition: .3s;
        }
      }
    }
    .right-col{
      .num{
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
    }
    &:hover{
      cursor: pointer;
      .all-lists-btn{
        color: var(--color-blue-dark);
        svg{
          path{
            fill: var(--color-blue-dark);
          }
        }
      }
    }
  }
  .content-block{
    display: flex;
    flex-direction: column;
  }
  .upload-eml-input{
    display: none;
  }
}
.content{
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .heading-block{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 6px 16px;
    column-gap: 24px;
    border-bottom: 1px solid var(--color-border);
    .heading-block__button{
      height: 32px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      background: var(--color-blue);
      color: var(--color-white);
      column-gap: 4px;
      transition: .3s;
      padding: 0 10px;
      svg{
        path{
          transition: .3s;
        }
      }
      &:hover{
        color: var(--color-white);
        background: var(--color-blue-dark);
        svg{
          path{
            fill: var(--color-white);
          }
        }
      }
    }
    .heading-block__button_light{
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      background: none;
      color: var(--color-blue-dark);
      column-gap: 4px;
      transition: .3s;
      padding: 0;
      span{
        color: var(--color-blue-dark);
        transition: .3s;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
      svg{
        path{
          transition: .3s;
        }
      }
      &:hover{
        color: var(--color-blue);
        span{
          color: var(--color-blue);
          transition: .3s;
        }
        svg{
          path{
            stroke: var(--color-blue);
          }
        }
      }
      &.disabled{
        pointer-events: none;
        opacity: .5;
      }
      &.tags-button{
        position: relative;
      }
    }
    &.disabled{
      .heading-block__button_light{
        pointer-events: none;
        opacity: .5;
      }
    }
    .create-folder-button{
      border: 1px solid var(--color-blue-dark);
      height: 32px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 160px;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      color: var(--color-blue-dark);
      column-gap: 4px;
      transition: .3s;
      svg{
        path{
          transition: .3s;
        }
      }
      &:hover{
        color: var(--color-white);
        border-color: var(--color-white);
        background: var(--color-blue-dark);
        svg{
          path{
            fill: var(--color-white);
          }
        }
      }
    }
    .heading-action-menu{
      position: relative;
      display: flex;
      align-items: center;
      svg{
        use{
          pointer-events: none;
        }
      }
      &:hover{
        cursor: pointer;
      }
    }
    .heading-action-sub-menu{
      position: absolute;
      padding: 8px;
      display: none;
      flex-direction: column;
      row-gap: 1px;
      left: 50%;
      top: 0;
      background: var(--color-white);
      z-index: 9;
      border-radius: 4px;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);
      // width: fit-content;
      width: auto;
      white-space: nowrap;
      &.show{
        display: flex;
      }
      .heading-block__button_light{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        svg{
          min-width: 24px;
        }
      }
    }

  }
  .nav-block{
    border-bottom: 1px solid var(--color-border);
    // height: 44px;
    display: flex;
    align-items: center;
    padding-left: 8px;
    padding-right: 16px;
    column-gap: 16px;
    .nav-button{
      width: 80px;
      height: 44px;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      color: var(--color-new-dark-gray);
      transition: .3s;
      position: relative;
      &:hover{
        color: var(--color-blue-dark);
        transition: .3s;
      }
      &.active{
        color: var(--color-blue-dark);
        &::after{
          content: '';
          position: absolute;
          display: flex;
          width: 100%;
          border-bottom: 2px solid var(--color-blue-dark);
          bottom: -1px;
        }
      }
    }
  }
  .user-info-block{
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    padding: 12px 16px;
    .user-info-block__title{
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding-bottom: 16px;
    }
    .user-block-row{
      display: flex;
      align-items: center;
      width: 100%;
      max-width: 460px;
      padding: 10px 0;
      border-bottom: 1px solid #DEE3EA;
      justify-content: space-between;
      &.first{
        border-top: 1px solid #DEE3EA;
      }
      &.signature-row{
        padding: 15px 0;
      }
      .col{
        display: flex;
        flex-direction: column;
        row-gap: 8px;

      }
      .col__title{
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: #787F89;
      }
      .col__text{
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .col__button{
        display: flex;
        align-items: center;
        color: var(--color-blue-dark);
        transition: .3s;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        svg{
          path{
            transition: .3s;
          }
        }
        &:hover{
          transition: .3s;
          color: var(--color-blue);
          svg{
            path{
              fill: var(--color-blue)
            }
          }
        }
      }
    }
  }
}
.search-block{
  width: 200px;
  height: 32px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  background: var(--color-gray-lightest);
  border: 1px solid var(--color-gray-light);
  border-radius: 4px;
  padding: 0 8px;
  .search-input{
    height: 100%;
    border: none;
    padding: 0;
  }

}
.my-custom-checkbox{
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  [type="checkbox"] {
    position: absolute;
    opacity: 0;
    z-index: -9999;
  }
  &:hover{
    cursor: pointer;
  }
  span {
    display: flex;
    align-items: center;
    &:before {
      content: "";
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      width: 16px;
      height: 16px;
      border-radius: 4px;
      border: 1px solid var(--color-gray-text);
      right: 0;
      left: 0;
      margin: auto;
    }
  }
  [type="checkbox"]:checked + span:before {
    content: url("data:image/svg+xml,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.5 1.02141C11.1868 0.673336 10.67 0.663685 10.3456 0.999847C10.3388 1.00688 10.3321 1.01407 10.3255 1.02141L4.76395 6.91934L1.88355 4.7889C1.55922 4.45274 1.04241 4.46239 0.72918 4.81046C0.423607 5.15001 0.423607 5.68829 0.72918 6.02784L4.18677 8.77773C4.50559 9.1198 5.02236 9.1198 5.34114 8.77773L11.4799 2.26035C11.8042 1.92414 11.8132 1.36948 11.5 1.02141Z' fill='%234B4B4B'/%3E%3C/svg%3E%0A");
  }
}
.mails-block{
  flex-grow: 1;
  // overflow-y: auto;
  height: 50%;
}
.mail-block-wrapper{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  justify-content: center;
}
.mail-detail-wrapper{
  box-sizing: border-box;
  flex-grow: 1;
  .mail-detail{
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;
    padding: 16px;
  }
  .name-row{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 4px;
    row-gap: 4px;
  }
  .name-text{
    padding-right: 4px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .tag{
    display: flex;
    align-items: center;
    column-gap: 4px;
    padding: 2px 6px;
    background: var(--color-violet);
    border-radius: 10px;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    min-height: 18px;
    svg{
      &:hover{
        cursor: pointer;
      }
    }
  }
  .mail-info-block{
    margin-top: 16px;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background: var(--color-gray-lightest);
    row-gap: 4px;
    .mail-info-block__row{
      display: flex;
      align-items: flex-start;
      column-gap: 12px;
      .name{
        width: 35px;
        min-width: 35px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-gray-text);
      }
      .text-block{
        display: flex;
        flex-wrap: wrap;
        column-gap: 4px;
        row-gap: 4px;
        width: 100%;
        max-width: 95%;
        .accordeon-button{
          margin-right: auto;
          display: none;
          span{
            pointer-events: none;
            color: var(--color-blue-dark);
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;

          }
          .showAll{
            display: flex;
          }
          .hideAll{
            display: none;
          }
          &.show{
            .showAll{
              display: none;
            }
            .hideAll{
              display: flex;
            }
          }
          &::after{
            content: url("data:image/svg+xml,%3Csvg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.27557 4.5C9.54284 4.5 9.67669 4.82314 9.4877 5.01213L6.21196 8.28787C6.0948 8.40502 5.90485 8.40502 5.7877 8.28787L2.51197 5.01213C2.32298 4.82314 2.45683 4.5 2.7241 4.5L9.27557 4.5Z' fill='%23094172'/%3E%3C/svg%3E%0A");
            margin-left: 4px;
          }
        }
        &_accordeon{
          flex-direction: column;
          .accordeon-button{
            display: flex;
          }
        }
        
      }
      .text, .text-block__item{
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        &.crop{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
          
        }
      }
    }
  }
  .files-block{
    padding-top: 8px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 8px;
    row-gap: 8px;
    .file{
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 2px;
      width: 66px;
      min-width: 66px;
      .file-name{
        padding-top: 2px;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline;
        max-width: 100%;
      }
      .file-size{
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-gray-text);
      }
      .file-img{
        background-image: url("data:image/svg+xml,%3Csvg width='40' height='48' viewBox='0 0 40 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3 48H37C38.6569 48 40 46.6569 40 45V13L27 0H3C1.34315 0 0 1.34315 0 3V45C0 46.6569 1.34315 48 3 48Z' fill='%23DEE3EA'/%3E%3Cpath d='M12.9506 31.6148L19.4913 12V28.2712C19.4913 28.5016 19.3571 28.7106 19.1485 28.8052L12.9506 31.6148Z' fill='%239AA3B0'/%3E%3Cpath d='M27.0494 31.6148L20.5087 12V28.2712C20.5087 28.5016 20.6429 28.7106 20.8515 28.8052L27.0494 31.6148Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.6601 17.2724C12.789 17.942 8.22674 22.9613 8.22674 29.0532C8.22674 31.1083 8.74562 33.0403 9.65843 34.7247L19.2353 30.1223V30.9274L9.36213 35.6754L9.19424 35.3854C8.11702 33.525 7.5 31.3611 7.5 29.0532C7.5 22.5847 12.344 17.2562 18.5783 16.5451L18.6601 17.2724ZM31.7733 29.0532C31.7733 22.9613 27.211 17.942 21.3399 17.2724L21.4217 16.5451C27.656 17.2562 32.5 22.5847 32.5 29.0532C32.5 31.3611 31.883 33.525 30.8058 35.3854L30.6359 35.6788L20.7647 30.9412L20.7544 30.1223L30.3435 34.7212C31.2551 33.0376 31.7733 31.1068 31.7733 29.0532Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 33.5294L10.963 37.5732L10.6471 36.9141L19.2353 32.7059V33.5294Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 35.8823L12.6619 39.1399L12.3478 38.4798L19.2353 35.0772V35.8823Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 38.2243L14.2608 40.75L13.9466 40.09L19.2353 37.4192V38.2243Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 33.5294L29.2674 37.5292L29.5833 36.8701L20.7647 32.7059V33.5294Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 35.8823L27.7422 39.1399L28.0562 38.4798L20.7647 35.0772V35.8823Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 38.2243L26.1433 40.75L26.4574 40.09L20.7647 37.4192V38.2243Z' fill='%239AA3B0'/%3E%3Cpath d='M40 13L30 13C28.3431 13 27 11.6569 27 10L27 -1.82822e-07L32.881 5.98L40 13Z' fill='%23BDCBD6'/%3E%3C/svg%3E%0A");
        background-size: cover;
        background-position: center;
        width: 40px;
        height: 48px;
      }
    }
  }
  .mail-text-block{
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    // max-width: 600px;
    /deep/{
      strong{
        font-weight: bold;
        &.date-text{
          font-weight: normal;
          font-size: 13px;
          color: #9AA3B0;
        }
      }
      em{
        font-style: italic;
      }
      .ql-align-center{
        text-align: center;
      }
      .ql-align-right{
        text-align: right;
      }
      .ql-align-justify{
        text-align: justify;
      }
      blockquote{
        padding: 10px !important;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        background-color: var(--color-white-dark);
        border-left: 3px solid var(--color-gray);
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .fwd-text_first{
        margin-top: 16px;
      }
      .fwd-text_last{
        margin-bottom: 8px;
      }
      .fwd-text{
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-dark);
      }
      .ql-syntax, pre{
        background: var(--color-dark);
        color: var(--color-yellow);
        padding: 4px;
        border-radius: 4px;
        width: fit-content;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      ol{
        padding-left: 16px;
        li{
          list-style-type: decimal;
        }
      }
      ul{
        padding-left: 16px;
        li{
          list-style-type: disc;
        }
      }
      p{
        white-space: normal;
      }
      @for $i from 1 to 9{
        $paddingLeft: $i * 10 + '%';
        .ql-indent-#{$i}{
          padding-left: #{$paddingLeft};
        }
      }
      h1{font-size: 2em;}
      h2{font-size: 1.5em;}
      h3{font-size: 1.17em}
      h4{font-size: 1em;}
      h5{font-size: .83em;}
      h6{font-size: .67em;}
      pre{
        max-width: 100%;
        word-wrap: break-word;
        white-space: pre-wrap;
      }
      .signature{
        // margin-top: 30px;
        position: relative;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        white-space: pre-wrap;
      }
      .signature-arrow{
        margin-top: 30px;
      }
      .draft-text{
        display: block;
        height: 1px;
        width: 1px;
        overflow: hidden;
      }
    }
    .text{
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    // .signature{
    //   margin-top: 30px;
    //   position: relative;
    //   font-size: 14px;
    //   font-style: normal;
    //   font-weight: 400;
    //   line-height: normal;
    //   &::before{
    //     content: '--';
    //     position: absolute;
    //     top: -16px;
    //     font-size: 14px;
    //     font-style: normal;
    //     font-weight: 400;
    //     line-height: normal;
    //   }
    // }
    .mails-history{
      margin-top: 16px;
    }
  }
  .mail-farme{
    border: 1px solid red;
    display: flex;
    align-self: stretch;
  }
  .mail-placeholder{
    // border: 1px solid red;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: var(--color-bgc-page);
    .text{
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding-top: 16px;
    }
  }
}
.mail-loader{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgba($color: #fff, $alpha: 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .sk-fading-circle {
    $circleCount: 12;
    $animationDuration: 1.2s;

    width: $spinkit-size;
    height: $spinkit-size;
    position: relative;
    margin: auto;

    .sk-circle {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    .sk-circle:before {
      content: '';
      display: block;
      margin: 0 auto;
      width: 15%;
      height: 15%;
      background-color: $spinkit-spinner-color;
      border-radius: 100%;
      animation: sk-fading-circle-delay $animationDuration infinite ease-in-out both;
    }

    @for $i from 2 through $circleCount {
      .sk-circle-#{$i} {
        transform: rotate((360deg / $circleCount * ($i - 1)));
      }
    }

    @for $i from 2 through $circleCount {
      .sk-circle-#{$i}:before {
        animation-delay: (-$animationDuration + $animationDuration / $circleCount * ($i - 1));
      }
    }
  }

  @keyframes sk-fading-circle-delay {
    0%, 39%, 100% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
  }
}
.no-result-block{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: rgba($color: #fff, $alpha: 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .list-empty{
    display: flex;
    flex-direction: column;
    align-items: center;
    .text{
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding-top: 16px;
      text-align: center;
    }
  }
}
.blue-button-text {
  color: var(--color-blue-dark);
  &:hover {
    color: var(--color-blue)
  }
  &:active {
    color: var(--color-dark)
  }
}
.hideAttach {
  height: 18px;
  overflow: hidden;
}
.wrap-attach {
  width: calc(100% - 90px);
}
.file {
  position: relative;
  .download-file {
    display: none;
    z-index: 10;
    background-color: var(--color-modal);
    border-radius: 200px;
    position: absolute;
    top: 0px;
    right: 5px;
  }
  .click-zone {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &:hover {
    .download-file {
      display: block;
      cursor: pointer;
    }
  }
}
</style>